import React from 'react' 
import UseLang from '../../../../hooks/UseLang'

function Relevamiento() {
    return (
        <div  id="p3">
            <UseLang es> 
                <h3 id="relevamiento">Relevamiento</h3>
                <h4 id="consulta">Consulta con expertos</h4>
                <p>Se realizaron consultas a expertos de varias organizaciones y se les pregunt&oacute; sobre las siguientes
                    cuestiones:</p>
                <p>¿Cu&aacute;les son las soluciones anti-DDOS que existen en el mercado (pagas versus de c&oacute;digo
                    abierto)? ¿Cu&aacute;les se usan en general?</p>
                <p>¿Cu&aacute;les son las soluciones m&aacute;s usadas en Latinoam&eacute;rica y Caribe (LAC)? Si no se usan,
                    ¿cu&aacute;l es la causa?</p>
                <p>¿Cu&aacute;nto cuesta una soluci&oacute;n? ¿Cu&aacute;nto cuesta su operaci&oacute;n?</p>
                <p>¿Cu&aacute;nto cuesta un ataque?</p>
                <p>Adem&aacute;s, se indag&oacute; sobre buenas pr&aacute;cticas y t&eacute;cnicas de mitigaci&oacute;n de DDoS.
                </p>

                <h4 id="antiddos">Soluciones anti-DDoS en el mercado</h4>
                <p>En el mercado hay varias soluciones anti-DDoS, ofrecidas por diferentes proveedores. Las que se listan a
                    continuaci&oacute;n son algunas de las disponibles. La elecci&oacute;n de la mejor soluci&oacute;n para una
                    organizaci&oacute;n depende de diversos factores, como el presupuesto, el nivel de protecci&oacute;n
                    requerido y la infraestructura.</p>


                <h5 id="cloudfare">Cloudfare [1]:</h5>
                <p><strong>Descripci&oacute;n:</strong> Cloudflare es una de las soluciones m&aacute;s populares para la
                    mitigaci&oacute;n de DDoS. Ofrece protecci&oacute;n a nivel de red y aplicaci&oacute;n, con una
                    infraestructura global que dispersa el tr&aacute;fico malicioso.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Protecci&oacute;n DDoS, CDN (Content Delivery Network), WAF (Web
                    Application Firewall), y DNS seguro.</p>
                <p><strong>Ventajas:</strong> F&aacute;cil de implementar, escalabilidad global, an&aacute;lisis en tiempo real,
                    y coste efectivo para sitios de todos los tama&ntilde;os.</p>
                <p>Funcionalidades m&aacute;s relevantes y tipos de detecci&oacute;n que implementa
                    <ul>
                        <li>Detecta y mitiga ataques DDoS en red (volum&eacute;tricos), nivel de transporte (como SYN Floods) y
                            nivel de aplicaci&oacute;n (ataques HTTP/S).</li>
                        <li>Bloquea tr&aacute;fico malicioso, bots no deseados y amenazas de capa 7 para proteger sitios web y API.
                        </li>
                        <li>Ofrece Web Application Firewall (WAF) que detecta y bloquea patrones de ataques, como inyecciones SQL y
                            cross-site scripting (XSS).</li>
                    </ul>
                </p>


                <h5 id="akamai">Akamai:</h5>
                <p><strong>Descripci&oacute;n:</strong> Akamai es conocido por su red de entrega de contenido aunque
                    tambi&eacute;n ofrece robustas capacidades de mitigaci&oacute;n de DDoS a trav&eacute;s de su servicio Kona
                    Site Defender.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Protecci&oacute;n a nivel de red y aplicaci&oacute;n,
                    distribuci&oacute;n de tr&aacute;fico a trav&eacute;s de una red global, y herramientas avanzadas de
                    an&aacute;lisis y monitoreo.</p>
                <p><strong>Ventajas:</strong> Amplia red de distribuci&oacute;n, soporte para grandes vol&uacute;menes de
                    tr&aacute;fico, y alta fiabilidad.</p>
                <p>Funcionalidades m&aacute;s relevantes y tipos de detecci&oacute;n que implementa
                    <ul>
                        <li>Detecta y mitiga ataques DDoS de gran escala y baja latencia, especializados en ataques en red y
                            aplicaciones.</li>
                        <li>Protege contra ataques volum&eacute;tricos, ataques de agotamiento de recursos y ataques a la capa de
                            aplicaci&oacute;n que pueden interrumpir la disponibilidad.</li>
                        <li>Utiliza un sistema global de red distribuida para detectar patrones de ataque y filtrar el
                            tr&aacute;fico malicioso antes de que llegue a los servidores de destino</li>
                    </ul>
                </p>
                <p><a href="https://www.akamai.com/" target="_blank" rel="noreferrer">https://www.akamai.com/</a></p>


                <h5 id="aws">Amazon Web Services (AWS) Shield:</h5>
                <p><strong>Descripci&oacute;n:</strong> AWS Shield es una soluci&oacute;n de mitigaci&oacute;n de DDoS integrada
                    en la infraestructura de AWS. Disponible en dos niveles: standard y advanced.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Protecci&oacute;n contra ataques a nivel de red y aplicaci&oacute;n,
                    integraci&oacute;n con otros servicios de AWS, y capacidades avanzadas de monitoreo y respuesta.</p>
                <p><strong>Ventajas:</strong> Integraci&oacute;n nativa con AWS, protecci&oacute;n autom&aacute;tica y
                    escalabilidad, opciones de informes detallados y soporte adicional con Shield Advanced.</p>
                <p>Funcionalidades m&aacute;s relevantes y tipos de detecci&oacute;n que implementa
                    <ul>
                        <li>Detecta y mitiga ataques DDoS de nivel 3 (red) y nivel 4 (transporte), as&iacute; como algunos ataques
                            de capa 7 (aplicaci&oacute;n).</li>
                        <li>AWS ofrece dos niveles: Shield Standard (protecci&oacute;n b&aacute;sica integrada para todos los
                            clientes de AWS) y Shield Advanced (protecci&oacute;n adicional contra ataques m&aacute;s sofisticados).
                            Shield Advanced se integra con otros servicios de AWS para una mayor visibilidad y respuesta a
                            incidentes de seguridad.</li>
                    </ul>
                </p>
                <p><a href="https://aws.amazon.com/es/shield/" target="_blank" rel="noreferrer">https://aws.amazon.com/es/shield/</a></p>


                <h5 id="google">Google Cloud Armor:</h5>
                <p><strong>Descripci&oacute;n:</strong> Google Cloud Armor proporciona protecci&oacute;n DDoS para aplicaciones
                    alojadas en Google Cloud, utilizando la infraestructura global de Google.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Pol&iacute;ticas de seguridad basadas en reglas, mitigaci&oacute;n
                    de ataques a nivel de red y aplicaci&oacute;n, y protecci&oacute;n contra ataques volum&eacute;tricos y de
                    aplicaci&oacute;n.</p>
                <p><strong>Ventajas:</strong> Integraci&oacute;n nativa con Google Cloud, f&aacute;cil de configurar y
                    gestionar, y escalabilidad global.</p>
                <p>Funcionalidades m&aacute;s relevantes y tipos de detecci&oacute;n que implementa
                    <ul>
                        <li>Proporciona protecci&oacute;n contra ataques DDoS y otras amenazas espec&iacute;ficas a las aplicaciones
                            alojadas en Google Cloud.</li>
                        <li>Incluye un WAF que detecta y bloquea ataques de capa 7, como SQLi y XSS.</li>
                        <li>Utiliza inteligencia artificial y aprendizaje autom&aacute;tico para identificar patrones
                            an&oacute;malos de tr&aacute;fico y diferenciar el tr&aacute;fico malicioso del tr&aacute;fico
                            leg&iacute;timo.</li>
                    </ul>
                </p>
                <p><a href="https://cloud.google.com/armor/docs?hl=es-419"
                    target="_blank" rel="noreferrer">https://cloud.google.com/armor/docs?hl=es-419</a></p>


                <h5 id="imperva">Imperva Incapsula:</h5>
                <p><strong>Descripci&oacute;n:</strong> Imperva Incapsula ofrece protecci&oacute;n DDoS para aplicaciones web y
                    servicios basados en la nube.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Mitigaci&oacute;n de DDoS a nivel de red y aplicaci&oacute;n, WAF,
                    protecci&oacute;n contra bots, y capacidades de monitoreo y an&aacute;lisis en tiempo real.</p>
                <p><strong>Ventajas:</strong> Protecci&oacute;n integral contra diversos tipos de ataques, f&aacute;cil
                    implementaci&oacute;n, y opciones avanzadas de configuraci&oacute;n y personalizaci&oacute;n.</p>
                <p>Funcionalidades m&aacute;s relevantes y tipos de detecci&oacute;n que implementa
                    <ul>
                        <li>Protege aplicaciones web de ataques DDoS, ataques de capa de aplicaci&oacute;n (nivel 7) y
                            tr&aacute;fico malicioso en general.</li>
                        <li>Incorpora protecci&oacute;n contra bots y WAF avanzado para mitigar amenazas como inyecciones y accesos
                            no autorizados.</li>
                        <li>Emplea una red global de servidores para detectar ataques y limpiar el tr&aacute;fico antes de que
                            llegue a las aplicaciones protegidas.</li>
                    </ul>
                </p>
                <p><a href="https://www.imperva.com/" target="_blank" rel="noreferrer">https://www.imperva.com/</a></p>


                <h5 id="arbor">Arbor Networks (NETSCOUT):</h5>
                <p><strong>Descripci&oacute;n:</strong> Arbor Networks es una soluci&oacute;n de seguridad que se enfoca en la
                    protecci&oacute;n contra DDoS, utilizada tanto por proveedores de servicios como por empresas.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Detecci&oacute;n y mitigaci&oacute;n de ataques en tiempo real,
                    inteligencia basada en la red global, y an&aacute;lisis detallados.</p>
                <p><strong>Ventajas:</strong> Amplia experiencia y reputaci&oacute;n en mitigaci&oacute;n de DDoS, soporte para
                    grandes infraestructuras, y herramientas avanzadas de an&aacute;lisis.</p>
                <p>Funcionalidades m&aacute;s relevantes y tipos de detecci&oacute;n que implementa
                    <ul>
                        <li>Se especializa en detecci&oacute;n y mitigaci&oacute;n de ataques DDoS volum&eacute;tricos de gran
                            escala y ataques de aplicaci&oacute;n dirigidos a empresas y proveedores de servicios.</li>
                        <li>Utiliza inteligencia de amenazas en tiempo real para responder r&aacute;pidamente a patrones de ataque y
                            desviar el tr&aacute;fico no deseado.</li>
                        <li>Incorpora an&aacute;lisis avanzados y visibilidad de tr&aacute;fico en tiempo real para mitigar amenazas
                            de red y mejorar la respuesta ante incidentes.</li>
                    </ul>
                </p>
                <p><a href="https://www.netscout.com/solutions/service-provider-ddos-protection"
                    target="_blank" rel="noreferrer">https://www.netscout.com/solutions/service-provider-ddos-protection</a></p>


                <h5 id="f5n">F5 Networks:</h5>
                <p><strong>Descripci&oacute;n:</strong> F5 Networks ofrece soluciones de mitigaci&oacute;n de DDoS que protegen
                    aplicaciones y redes mediante su sistema BIG-IP.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Mitigaci&oacute;n de DDoS a nivel de red y aplicaci&oacute;n, WAF,
                    balanceo de carga, y herramientas de monitoreo y an&aacute;lisis.</p>
                <p><strong>Ventajas:</strong> Enfoque h&iacute;brido de hardware y software, alta fiabilidad, y capacidad para
                    manejar grandes vol&uacute;menes de tr&aacute;fico.</p>
                <p>Funcionalidades m&aacute;s relevantes y tipos de detecci&oacute;n que implementa
                    <ul>
                        <li>Ofrece protecci&oacute;n contra ataques DDoS, Web Application Firewall (WAF) y mitigaci&oacute;n de bots
                            para entornos en la nube y locales.</li>
                        <li>Detecta ataques de capa de aplicaci&oacute;n, red y transporte, adem&aacute;s de ataques
                            volum&eacute;tricos.</li>
                        <li>La plataforma Silverline ofrece an&aacute;lisis y respuesta gestionada para bloquear ataques en tiempo
                            real y adaptarse a patrones de ataque emergentes.</li>
                    </ul>
                </p>
                <p><a href="https://www.f5.com/es_es" target="_blank" rel="noreferrer">https://www.f5.com/es_es</a></p>



                <table className="table">
                    <thead>
                        <tr>
                            <th>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                            </th>
                            <th>
                                <p><strong>Cloudflare</strong></p>
                            </th>
                            <th>
                                <p><strong>Akamai Prolexic</strong></p>
                            </th>
                            <th>
                                <p><strong>AWS Shield</strong></p>
                            </th>
                            <th>
                                <p><strong>Google Cloud Armor</strong></p>
                            </th>
                            <th>
                                <p><strong>Imperva Incapsula</strong></p>
                            </th>
                            <th>
                                <p><strong>Arbor Networks (NETSCOUT)</strong></p>
                            </th>
                            <th>
                                <p><strong>F5 Networks (Silverline)</strong></p>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>
                                <p><strong>Protecci&oacute;n de capa de red (L3/L4)</strong></p>
                            </th>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>Limitada a servicios en GCP</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Protecci&oacute;n de capa de aplicaci&oacute;n (L7)</strong></p>
                            </th>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>Solo con <em>Shield Advanced</em></p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Mitigaci&oacute;n en tiempo real</strong></p>
                            </th>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute; (con <em>Shield Advanced</em>)</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Escalabilidad autom&aacute;tica</strong></p>
                            </th>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>Limitada</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Personalizaci&oacute;n de reglas</strong></p>
                            </th>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>Limitado (requiere WAF separado)</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Monitoreo y alertas en tiempo real</strong></p>
                            </th>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute; (en <em>Shield Advanced</em>)</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Protecci&oacute;n siempre activa</strong></p>
                            </th>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute; (<em>Shield Advanced</em>)</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Red de distribuci&oacute;n de contenido (CDN)</strong></p>
                            </th>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute; (con CloudFront)</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                            <td>
                                <p>Limitada</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Protecci&oacute;n de DNS</strong></p>
                            </th>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Informe detallado de ataques</strong></p>
                            </th>
                            <td>
                                <p>Limitado</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>Solo en <em>Shield Advanced</em></p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Soporte de respuesta 24/7</strong></p>
                            </th>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>Solo en <em>Shield Advanced</em></p>
                            </td>
                            <td>
                                <p>Limitado</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                            <td>
                                <p>S&iacute;</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Opciones de implementaci&oacute;n</strong></p>
                            </th>
                            <td>
                                <p>Cloud (CDN)</p>
                            </td>
                            <td>
                                <p>Cloud (CDN)</p>
                            </td>
                            <td>
                                <p>Integrado en AWS</p>
                            </td>
                            <td>
                                <p>Integrado en Google Cloud</p>
                            </td>
                            <td>
                                <p>Cloud (CDN)</p>
                            </td>
                            <td>
                                <p>H&iacute;brido (Cloud + On-Premises)</p>
                            </td>
                            <td>
                                <p>Cloud</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Costo</strong></p>
                            </th>
                            <td>
                                <p>Free y planes premium</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Est&aacute;ndar (gratis); Advanced (premium)</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                        </tr>
                    </tbody>
                </table>



                <p>Las herramientas mencionadas son ampliamente utilizadas debido a su eficacia y capacidad para manejar grandes
                    vol&uacute;menes de tr&aacute;fico, as&iacute; como por su facilidad de integraci&oacute;n y uso. La
                    elecci&oacute;n de la herramienta adecuada depende de factores como la infraestructura, el presupuesto y las
                    necesidades espec&iacute;ficas de protecci&oacute;n de la organizaci&oacute;n.</p>

                <p>Adem&aacute;s de las herramientas presentadas, existen otras soluciones en el mercado. Las organizaciones
                    pueden consultar a proveedores de soluciones de seguridad, as&iacute; como tambi&eacute;n a sus ISP, que
                    muchas veces ofrecen el servicio de mitigaci&oacute;n de DDoS como un valor agregado a su servicio de
                    conectividad.</p>
                <p>En <a href="https://www.gartner.com/reviews/market/ddos-mitigation-solutions"
                    target="_blank" rel="noreferrer">https://www.gartner.com/reviews/market/ddos-mitigation-solutions</a> se establece un
                    ranking de preferencia de herramientas comerciales, el cual puede analizarse por regi&oacute;n. Este ranking
                    se construye de acuerdo con la valoraci&oacute;n que hacen los usuarios. Si bien no todas las herramientas
                    son valoradas por la misma cantidad de usuarios, estas pueden tenerse en cuenta a la hora de adoptar alguna.
                </p>
                <p>A continuaci&oacute;n, se presenta el ranking para la regi&oacute;n Latinoam&eacute;rica de las herramientas
                    descritas en la secci&oacute;n anterior (ordenado por cantidad de valoraciones y puntaje de la
                    valoraci&oacute;n).</p>


                <table className="table">
                    <thead>
                        <tr>
                            <th>Producto</th>
                            <th>Cantidad de valoraciones</th>
                            <th>Valoraci&oacute;n (escala de 0 a 5)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Cloudfare DDoS Protection</td>
                            <td>18</td>
                            <td>4.6</td>
                        </tr>
                        <tr>
                            <td>Imperva DDoS Protection</td>
                            <td>9</td>
                            <td>4.8</td>
                        </tr>
                        <tr>
                            <td>Akamai Edge DNS</td>
                            <td>3</td>
                            <td>4.7</td>
                        </tr>
                        <tr>
                            <td>Arbor Cloud</td>
                            <td>2</td>
                            <td>5</td>
                        </tr>
                        <tr>
                            <td>Amazon Web Services (AWS) Shield</td>
                            <td>1</td>
                            <td>5</td>
                        </tr>
                    </tbody>
                </table>

                <p>Google Cloud Armor y F5 Networks no se incluyen en la tabla porque no han sido valorados en el ranking de
                    Gartner. Adem&aacute;s, en dicho sitio puede consultarse el ranking de acuerdo al tama&ntilde;o y tipo de
                    organizaci&oacute;n tambi&eacute;n.</p>

                <p>Por otra parte, tambi&eacute;n existen herramientas de c&oacute;digo abierto con el mismo objetivo de
                    mitigaci&oacute;n de ataques de DDoS. Entre ellas vale la pena mencionar:</p>


                <h5 id="hap">Haproxy:</h5>
                <p><strong>Descripci&oacute;n:</strong> HAProxy es un proxy inverso gratuito, muy r&aacute;pido y confiable que
                    ofrece alta disponibilidad, equilibrio de carga y proxy para aplicaciones basadas en TCP y HTTP.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Es un balanceador de carga y proxy que puede ayudar a distribuir el
                    tr&aacute;fico de manera equitativa entre varios servidores.</p>
                <p><strong>Ventajas:</strong> Puede ser &uacute;til para manejar grandes vol&uacute;menes de tr&aacute;fico
                    durante un ataque DDoS.</p>
                <p><a href="https://github.com/haproxy" target="_blank" rel="noreferrer">https://github.com/haproxy</a></p>


                <h5 id="gate">Gatekeeper:</h5>
                <p><strong>Descripci&oacute;n:</strong> Gatekeeper es el primer sistema de protecci&oacute;n DDoS de
                    c&oacute;digo abierto, utilizado por operadores de redes de instituciones, proveedores de servicios y
                    contenidos, redes empresariales, etc.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Est&aacute; dise&ntilde;ado para escalar a cualquier ancho de banda
                    m&aacute;ximo. Su arquitectura est&aacute; geogr&aacute;ficamente distribuida mientras que la
                    pol&iacute;tica de red que describe todas las decisiones que deben aplicarse al tr&aacute;fico entrante
                    est&aacute; centralizada.</p>
                <p><strong>Ventajas:</strong> Su posibilidad de escalar a cualquier ancho de banda hace que pueda resistir
                    ataques DDoS actuales y futuros. Y su pol&iacute;tica centralizada permite a los operadores de red
                    aprovechar algoritmos distribuidos que no ser&iacute;an viables con una latencia muy alta (por ejemplo,
                    bases de datos distribuidas) y combatir m&uacute;ltiples ataques DDoS multivectoriales a la vez.</p>
                <p><a href="https://github.com/AltraMayor/gatekeeper"
                    target="_blank" rel="noreferrer">https://github.com/AltraMayor/gatekeeper</a></p>


                <h5 id="fast">FastNetMon:</h5>
                <p><strong>Descripci&oacute;n:</strong> Un detector/sensor DDoS de alto rendimiento construido sobre
                    m&uacute;ltiples motores de captura de paquetes: NetFlow, IPFIX, sFlow, AF_PACKET.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Detecta hosts en la red que env&iacute;an o reciben grandes
                    vol&uacute;menes de tr&aacute;fico, paquetes/bytes/flujos por segundo y realiza una acci&oacute;n
                    configurable para manejar ese evento. Estas acciones configurables incluyen notificarle, llamar al script o
                    realizar anuncios BGP.</p>
                <p><strong>Ventajas:</strong> Cuenta con m&uacute;ltiples ventajas como: detectar DoS/DDoS en tan solo 1-2
                    segundos, escalar hasta terabits en un solo servidor (sFlow, Netflow, IPFIX) o hasta 40G + en modo espejo,
                    permite configurar umbrales por subred, posee notificaciones por correo electr&oacute;nico sobre ataques
                    detectados y cuenta con soporte completo para IPv6.</p>
                <p><a href="https://github.com/pavel-odintsov/fastnetmon/"
                    target="_blank" rel="noreferrer">https://github.com/pavel-odintsov/fastnetmon/</a></p>


                <p>Descrito este conjunto de herramientas, tanto comerciales como de c&oacute;digo abierto, no debemos dejar de
                    mencionar que algunos ISP o proveedores de seguridad tambi&eacute;n ofrecen servicios de depuraci&oacute;n
                    de DDoS. Estos consisten en enviar a la organizaci&oacute;n el tr&aacute;fico limpio despu&eacute;s de
                    absorber el ataque, porque se supone que tienen la inteligencia para detectar y descartar la mayor&iacute;a
                    de los tipos de ataques DDoS. Estos servicios deben complementarse con soluciones DNS y BGP para que sean
                    eficaces.</p>


                <h4 id="uso">Uso de oluciones anti-DDoS en el mercado</h4>
                <p>Entre las herramientas que ofrece el mercado (cuya descripci&oacute;n se incluy&oacute; en la parte 1 de este
                    trabajo) <strong>Cloudflare, Akamai, Amazon Web Services (AWS) Shield, Google Cloud Armor, Imperva
                        Incapsula, Arbor Networks (NETSCOUT)</strong> y <strong>F5 Networks</strong> son las m&aacute;s
                    usadas/valoradas en general. Por su parte, <strong>Haproxy, Gatekeeper y FastNetMon</strong> se encuentran
                    entre las soluciones de c&oacute;digo abierto disponibles.</p>
                <p>A fin de conocer de primera mano qu&eacute; ocurre en Latinoam&eacute;rica y Caribe respecto al uso de las
                    soluciones, se entrevist&oacute; a un conjunto de organizaciones de esta regi&oacute;n, distribuidas de la
                    siguiente manera:</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_1.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Consultadas sobre si cuentan con una soluci&oacute;n anti-DDoS, un 70 % respondi&oacute; que s&iacute;. El 30
                    % a&uacute;n no ha implementado ninguna soluci&oacute;n para mitigar los ataques de DDoS.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_2.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>De ese 70%, las soluciones que implementan son las siguientes:</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_3.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Para evaluar por qu&eacute; no se usan soluciones anti-DDoS, se consult&oacute; sobre si las organizaciones
                    las consideraban necesarias y, en los casos afirmativos, sobre las dificultades que hacen que no las
                    implementen o las dilaten. Respecto a esto observamos que, en sus an&aacute;lisis de riesgos, todas las
                    organizaciones entrevistadas consideran los ataques de DDoS. Adicionalmente, el 50 % de ellas contestaron
                    haber sufrido alg&uacute;n incidente en los seis meses previos; un 20 % de estos incidentes fueron ataques
                    de DDoS.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_4.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Podemos inferir que no solo analizan ese riesgo, sino que la amenaza se ha concretado en algunos casos. Por
                    eso, las organizaciones que no cuentan con soluciones anti-DDOS se ver&iacute;an muy desprotegidas.</p>
                <p>Adem&aacute;s, si bien el 30 % de las organizaciones no cuenta con herramientas anti-DDoS, la gran
                    mayor&iacute;a s&iacute; tiene un procedimiento o protocolo de actuaci&oacute;n (80%) o, al menos, piensa
                    incluirlo (20%).</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_5.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>A partir de esto podemos pensar que es necesario contar con una herramienta o soluci&oacute;n que d&eacute;
                    soporte a dicho protocolo de actuaci&oacute;n y que se pueda usar para mitigar este tipo de ataques. Esto se
                    puede afirmar en funci&oacute;n de lo que las mismas organizaciones manifestaron. Todas las que no cuentan
                    con soluciones anti-DDoS expresaron fuerte inter&eacute;s en acceder a alguna soluci&oacute;n para mitigar
                    estos ataques.</p>
                <p>Entonces, ¿por qu&eacute; hay organizaciones que a&uacute;n no cuentan con alguna soluci&oacute;n anti-DDoS?
                    Las razones expresadas fueron:
                    <ul>
                        <li>Costo elevado de las soluciones (40%)</li>
                        <li>Se priorizan otros servicios de seguridad a implementar/contratar (40%)</li>
                        <li>Se encuentran en plan de desarrollo o de implementaci&oacute;n de plan piloto (20%)</li>
                    </ul>
                </p>


                <h4 id="costoa">Costo de adquisici&oacute;n y operaci&oacute;n de las soluciones anti-DDoS</h4>
                <p>Al indagar respecto a los costos de las soluciones y su operaci&oacute;n, hay distintas variantes de
                    productos y el costo puede variar significativamente dependiendo de varios factores: el tama&ntilde;o de la
                    organizaci&oacute;n, el nivel de protecci&oacute;n requerido, el nivel de soporte proporcionado, el
                    proveedor del servicio y el tipo de soluci&oacute;n (basada en la nube, on-premise, h&iacute;brida, a
                    medida, etc.).</p>
                <p>Todo esto hace que sea muy compleja la valoraci&oacute;n. Es decir, una misma soluci&oacute;n puede y suele
                    tener diferentes costos de adquisici&oacute;n y operaci&oacute;n, por lo que no podemos decir que la
                    soluci&oacute;n X cuesta Y d&oacute;lares, por ejemplo. Adicionalmente, mil d&oacute;lares pueden resultar
                    poco para una organizaci&oacute;n y mucho para otra.</p>
                <p>Por esta raz&oacute;n se valoraron los costos de adquisici&oacute;n y operaci&oacute;n de las diferentes
                    soluciones en funci&oacute;n de los presupuestos y costos de operaci&oacute;n mensual del &aacute;rea de
                    seguridad o TI de cada organizaci&oacute;n, de forma de obtener resultados cercanos a la realidad de cada
                    una.</p>
                <p>Dicho esto, y a partir de la informaci&oacute;n brindada por los entrevistados, pudimos observar que muchos
                    (casi un 43 %) no conocen los costos de la adquisici&oacute;n o renta de soluciones anti-DDoS o no cuentan
                    con dicha informaci&oacute;n por restricciones de su rol dentro de la organizaci&oacute;n.</p>
                <p>Para aproximadamente un 43 % de las organizaciones que cuentan con una soluci&oacute;n anti-DDoS, el costo
                    estimado es de entre el 1 % y el 20 % del valor promedio de operaci&oacute;n del CSIRT o &aacute;rea de TI
                    de la organizaci&oacute;n, el cual representa un porcentaje elevado. Para poco m&aacute;s del 14 % restante,
                    ese costo se ubica entre el 21 % y el 50 %.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_6.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Adem&aacute;s, se pudo saber que el 57 % de las organizaciones destina entre el 1 % y el 10 % del presupuesto
                    mensual de operaci&oacute;n del &aacute;rea de seguridad/TI a la operaci&oacute;n de la soluci&oacute;n
                    anti-DDoS. Otras pueden incluso llegar a invertir entre el 41 % y el 50% del presupuesto de operaci&oacute;n
                    mensual del &aacute;rea.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_7.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />


                <h4 id="costoat">Costo de los ataques</h4>
                <p>Al igual que con los costos de adquisici&oacute;n y operaci&oacute;n de una soluci&oacute;n anti-DDoS, el
                    costo de un ataque resulta tambi&eacute;n complejo de estimar por la diversidad de tipos y tama&ntilde;os de
                    las organizaciones, as&iacute; como de sus capacidades t&eacute;cnicas y econ&oacute;micas.</p>
                <p>Por esto tambi&eacute;n se pidi&oacute; a las organizaciones que reportaron haber sufrido un incidente que
                    estimaran el costo asociado al ataque en funci&oacute;n del valor promedio de producci&oacute;n mensual de
                    la organizaci&oacute;n.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_8.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Es importante notar que las que respondieron «No sabe/No aplica» son organizaciones multi-tenant que no
                    tuvieron el incidente directamente (lo tuvo alguna de sus organizaciones miembro). Por eso hay ciertos
                    detalles (como los econ&oacute;micos) que no est&aacute;n necesariamente a su alcance. En cualquier caso, el
                    costo econ&oacute;mico es significativo en relaci&oacute;n con el valor promedio de producci&oacute;n
                    mensual de la organizaci&oacute;n.</p>
                <p>La mayor&iacute;a de las organizaciones que respondieron a esta pregunta son del &aacute;rea de la academia
                    (universidades o NREN) y al menos una atiende a diferentes organizaciones en las &aacute;reas de banca, de
                    seguros, sector financiero, comercial y gubernamental.</p>
                <p>Adicionalmente, indagamos acerca de otros costos no tangibles asociados con el incidente, ante lo cual
                    obtuvimos:</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_9.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Es claro que siempre existen otras afectaciones no tangibles econ&oacute;micamente o al menos no
                    f&aacute;cilmente estimables econ&oacute;micamente. Algunas de ellas, dependiendo del sector en donde se
                    produzcan, pueden incluso resultar m&aacute;s impactantes. Por ejemplo, el da&ntilde;o a la imagen o
                    reputaci&oacute;n de un banco puede resultar catastr&oacute;fico, pues es muy sencillo que la gente retire
                    sus haberes de la instituci&oacute;n al perder la confianza.</p>
                <p>Por otra parte, respecto al costo de los ataques de DDOS —y m&aacute;s all&aacute; de los relevados en las
                    entrevistas— el sitio <a href="https://pulse.internetsociety.org/netloss"
                        target="_blank" rel="noreferrer">https://pulse.internetsociety.org/netloss</a> ofrece una calculadora que muestra
                    cu&aacute;l es el costo para un pa&iacute;s de un corte de Internet o un bloqueo de contenido. Esta
                    calculadora utiliza un marco econ&oacute;mico para estimar el impacto de la no disponibilidad de Internet o
                    de contenidos en una serie de resultados econ&oacute;micos, sociales y de otro tipo, y emplea herramientas
                    econom&eacute;tricas para proporcionar una estimaci&oacute;n rigurosa y precisa del impacto
                    econ&oacute;mico. La metodolog&iacute;a se basa en conjuntos de datos abiertos para hacer el c&aacute;lculo,
                    lo que determina que la metodolog&iacute;a sea reproducible y <a
                        href="https://pulse.internetsociety.org/wp-content/uploads/2023/06/Methodology_Internet-Society-Pulse-NetLoss-Calculator_June-2023.pdf"
                        target="_blank" rel="noreferrer"> transparente</a>.</p>
                <p>Por ca&iacute;da de Internet y bloqueo de contenido, calculado para 24 horas de corte (fecha: del 31/7/2024
                    al 1/8/2024).</p>





                <table className="table">
                    <thead>
                        <tr>
                            <th>
                                <p>&nbsp;</p>
                            </th>
                            <th colspan="3">
                                <p>Por ca&iacute;da de Internet</p>
                            </th>
                            <th colspan="3">
                                <p>Por bloqueo de contenido</p>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <p>Pa&iacute;s</p>
                            </td>
                            <td>
                                <p>P&eacute;rdida de producto bruto interno o paridad de poder
                                    adquisitivo (en USD)</p>
                            </td>
                            <td>
                                <p>Probabilidad de atravesar una ca&iacute;da de Internet en un
                                    a&ntilde;o determinado (en porcentaje)</p>
                            </td>
                            <td>
                                <p>P&eacute;rdida de inversi&oacute;n extranjera (en USD)
                                </p>
                            </td>
                            <td>
                                <p>P&eacute;rdida de producto bruto interno o paridad de poder
                                    adquisitivo (en USD)</p>
                            </td>
                            <td>
                                <p>Probabilidad de atravesar una ca&iacute;da de Internet en un
                                    a&ntilde;o determinado (en porcentaje)</p>
                            </td>
                            <td>
                                <p>P&eacute;rdida de inversi&oacute;n extranjera (en USD)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>ARGENTINA</p>
                            </td>
                            <td>
                                <p>USD $13,245,621</p>
                            </td>
                            <td>
                                <p>2.92 %</p>
                            </td>
                            <td>
                                <p>27</p>
                            </td>
                            <td>
                                <p>USD $1,766,083</p>
                            </td>
                            <td>
                                <p>2.92 %</p>
                            </td>
                            <td>
                                <p>3</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>ARUBA</p>
                            </td>
                            <td>
                                <p>USD $47,507</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>sin datos</p>
                            </td>
                            <td>
                                <p>USD $6,334</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>sin datos</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>BELICE</p>
                            </td>
                            <td>
                                <p>USD $53,102</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>sin datos</p>
                            </td>
                            <td>
                                <p>USD $7,080</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>sin datos</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>BOLIVIA</p>
                            </td>
                            <td>
                                <p>USD $1,234,840</p>
                            </td>
                            <td>
                                <p>2.98 %</p>
                            </td>
                            <td>
                                <p>2</p>
                            </td>
                            <td>
                                <p>USD $164,645</p>
                            </td>
                            <td>
                                <p>2.98 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>BRASIL</p>
                            </td>
                            <td>
                                <p>USD $ 41,208,368</p>
                            </td>
                            <td>
                                <p>2.72 %</p>
                            </td>
                            <td>
                                <p>253</p>
                            </td>
                            <td>
                                <p>USD $5,494,449</p>
                            </td>
                            <td>
                                <p>2.72 %</p>
                            </td>
                            <td>
                                <p>33</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>CHILE</p>
                            </td>
                            <td>
                                <p>USD $ 6,109,129</p>
                            </td>
                            <td>
                                <p>3.59 %</p>
                            </td>
                            <td>
                                <p>18</p>
                            </td>
                            <td>
                                <p>USD $814,551</p>
                            </td>
                            <td>
                                <p>3.59 %</p>
                            </td>
                            <td>
                                <p>2</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>COLOMBIA</p>
                            </td>
                            <td>
                                <p>USD $10,776,131</p>
                            </td>
                            <td>
                                <p>0%</p>
                            </td>
                            <td>
                                <p>78</p>
                            </td>
                            <td>
                                <p>USD $1,436,817</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>10</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>COSTA RICA</p>
                            </td>
                            <td>
                                <p>USD $1,338,233</p>
                            </td>
                            <td>
                                <p>3.03 %</p>
                            </td>
                            <td>
                                <p>8</p>
                            </td>
                            <td>
                                <p>USD $178,431</p>
                            </td>
                            <td>
                                <p>3.03 %</p>
                            </td>
                            <td>
                                <p>1</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>CUBA</p>
                            </td>
                            <td colspan="6">
                                <p>sin datos</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>REP&Uacute;BLICA DOMINICANA</p>
                            </td>
                            <td>
                                <p>USD $2,699,137</p>
                            </td>
                            <td>
                                <p>3.49 %</p>
                            </td>
                            <td>
                                <p>4</p>
                            </td>
                            <td>
                                <p>USD $359,885</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>ECUADOR</p>
                            </td>
                            <td>
                                <p>USD $2,684,813</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>3</p>
                            </td>
                            <td>
                                <p>USD $357,975</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>EL SALVADOR</p>
                            </td>
                            <td>
                                <p>USD $734,144</p>
                            </td>
                            <td>
                                <p>4.01 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $97,886</p>
                            </td>
                            <td>
                                <p>4.01 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>GUYANA FRANCESA</p>
                            </td>
                            <td>
                                <p>USD $321,851</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>1</p>
                            </td>
                            <td>
                                <p>USD $42,914</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>GUATEMALA</p>
                            </td>
                            <td>
                                <p>USD $2,277,611</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>1</p>
                            </td>
                            <td>
                                <p>USD $303,681</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>GUYANA</p>
                            </td>
                            <td>
                                <p>USD $321,851</p>
                            </td>
                            <td>
                                <p>0%</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $42,914</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>HAIT&Iacute;</p>
                            </td>
                            <td>
                                <p>USD $370,249</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>30</p>
                            </td>
                            <td>
                                <p>USD $49,367</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>4</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>HONDURAS</p>
                            </td>
                            <td>
                                <p>2.71 %</p>
                                <p>&nbsp;</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>6</p>
                            </td>
                            <td>
                                <p>USD $93,600</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>M&Eacute;XICO</p>
                            </td>
                            <td>
                                <p>USD $30,013,923</p>
                            </td>
                            <td>
                                <p>2.71 %</p>
                                <p>&nbsp;</p>
                            </td>
                            <td>
                                <p>16</p>
                            </td>
                            <td>
                                <p>USD $4,001,856</p>
                            </td>
                            <td>
                                <p>2.71 %</p>
                                <p>&nbsp;</p>
                            </td>
                            <td>
                                <p>12</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>ANTILLAS NEERLANDESAS</p>
                            </td>
                            <td>
                                <p>USD $19,526</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $2,603</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>NICARAGUA</p>
                            </td>
                            <td>
                                <p>USD $515,952</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>2</p>
                            </td>
                            <td>
                                <p>USD $68,794</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>PANAM&Aacute;</p>
                            </td>
                            <td>
                                <p>USD $1,573,209</p>
                            </td>
                            <td>
                                <p>2.74 %</p>
                            </td>
                            <td>
                                <p>3</p>
                            </td>
                            <td>
                                <p>USD $209,761</p>
                            </td>
                            <td>
                                <p>2.74 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>PARAGUAY</p>
                            </td>
                            <td>
                                <p>USD $1,089,434</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>4</p>
                            </td>
                            <td>
                                <p>USD $145,258</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>PER&Uacute;</p>
                            </td>
                            <td>
                                <p>USD $5,496,941</p>
                            </td>
                            <td>
                                <p>3.02 %</p>
                            </td>
                            <td>
                                <p>7</p>
                            </td>
                            <td>
                                <p>USD $732,925</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>3.02 %</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>SURINAME</p>
                            </td>
                            <td>
                                <p>USD $122,327</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $16,310</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>TRINIDAD Y TOBAGO</p>
                            </td>
                            <td>
                                <p>USD $451,804</p>
                            </td>
                            <td>
                                <p>2.52 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $60,241</p>
                            </td>
                            <td>
                                <p>2.52 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>URUGUAY</p>
                            </td>
                            <td>
                                <p>USD $1,105,827</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $147,444</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                    </tbody>
                </table>


                <h4 id="esquema">Esquemas de pago y licenciamiento</h4>
                <p>Adicionalmente, se estudiaron los modelos de precios, limitaciones y opciones de presencia en red para cada
                    soluci&oacute;n anti-DDoS mencionada:
                    <ol>
                        <li>Cloudflare DDoS Protection
                            <ul>
                                <li>Cobranza: Ofrecen desde planes gratuitos para sitios peque&ntilde;os hasta soluciones
                                    empresariales avanzadas. La protecci&oacute;n DDoS avanzada es parte de los planes de pago y
                                    est&aacute; incluida en Cloudflare Business y Enterprise.</li>
                                <li>Limitantes: Los planes gratuitos pueden limitar la mitigaci&oacute;n y no incluyen
                                    protecci&oacute;n personalizada para ataques espec&iacute;ficos. En los planes de pago, las
                                    limitaciones se basan en el plan adquirido.</li>
                                <li>Presencia en red: Cloudflare cuenta con una infraestructura global que permite proteger sitios
                                    en todo el mundo sin necesidad de configuraciones adicionales.</li>
                                <li>Licenciamiento: Los planes avanzados suelen ser de suscripci&oacute;n mensual o anual, y algunos
                                    servicios empresariales pueden tener tarifas personalizadas seg&uacute;n el uso y las
                                    necesidades de mitigaci&oacute;n.</li>
                            </ul>
                        </li>
                        <li>Imperva DDoS Protection
                            <ul>
                                <li>Cobranza: Imperva cobra de acuerdo al tr&aacute;fico y la complejidad de la protecci&oacute;n
                                    requerida. Ofrece precios personalizados para empresas con alto tr&aacute;fico y requisitos
                                    espec&iacute;ficos.</li>
                                <li>Limitantes: Algunos planes b&aacute;sicos limitan la capacidad de personalizaci&oacute;n y
                                    pueden no incluir todas las capas de protecci&oacute;n.</li>
                                <li>Presencia en red: Utiliza centros de mitigaci&oacute;n distribuidos globalmente, lo que permite
                                    gestionar ataques en m&uacute;ltiples regiones sin necesidad de infraestructuras adicionales.
                                </li>
                                <li>Licenciamiento: Basado en suscripci&oacute;n y, en algunos casos, en tarifas de acuerdo con el
                                    volumen de tr&aacute;fico mensual. Los planes suelen ser anuales y ajustados seg&uacute;n las
                                    necesidades.</li>
                            </ul>
                        </li>
                        <li>Akamai Edge DNS
                            <ul>
                                <li>Cobranza: Akamai cobra principalmente seg&uacute;n el tr&aacute;fico DNS y los niveles de
                                    servicio. Las tarifas pueden variar considerablemente, con precios personalizados para grandes
                                    empresas.</li>
                                <li>Limitantes: Algunos planes de entrada pueden no incluir todas las capas de protecci&oacute;n ni
                                    acceso completo a la red de mitigaci&oacute;n global.</li>
                                <li>Presencia en red: Gracias a su red global, Akamai permite la mitigaci&oacute;n a nivel DNS en
                                    m&uacute;ltiples ubicaciones. Este servicio est&aacute; dise&ntilde;ado para proteger de ataques
                                    distribuidos sin intervenci&oacute;n local adicional.</li>
                                <li>Licenciamiento: Generalmente, es un modelo de suscripci&oacute;n mensual o anual, y los precios
                                    pueden escalar de acuerdo con el tr&aacute;fico gestionado.</li>
                            </ul>
                        </li>
                        <li>Arbor Cloud
                            <ul>
                                <li>Cobranza: Arbor Cloud cobra en funci&oacute;n del volumen de tr&aacute;fico a mitigar y de las
                                    capacidades contratadas (como velocidad de mitigaci&oacute;n). La soluci&oacute;n puede ser
                                    costosa para redes con tr&aacute;fico alto.</li>
                                <li>Limitantes: Hay l&iacute;mites en la capacidad de tr&aacute;fico que cada plan puede gestionar.
                                    La configuraci&oacute;n y an&aacute;lisis tambi&eacute;n requieren recursos especializados.</li>
                                <li>Presencia en red: Arbor Cloud se integra con redes de centros de datos distribuidos y cuenta con
                                    una infraestructura de mitigaci&oacute;n global.</li>
                                <li>Licenciamiento: Suele ser una suscripci&oacute;n anual o mensual, y algunos servicios
                                    espec&iacute;ficos pueden cobrarse adicionalmente.</li>
                            </ul>
                        </li>
                        <li>Amazon Web Services (AWS) Shield
                            <ul>
                                <li>Cobranza: AWS Shield Standard es gratuito para usuarios de AWS, mientras que Shield Advanced
                                    tiene un costo basado en el tr&aacute;fico de mitigaci&oacute;n y la infraestructura protegida.
                                </li>
                                <li>Limitantes: Shield Standard tiene limitaciones en el tipo y volumen de ataques que puede
                                    mitigar. Shield Advanced tiene l&iacute;mites ajustables seg&uacute;n la configuraci&oacute;n y
                                    el volumen de tr&aacute;fico.</li>
                                <li>Presencia en red: AWS Shield aprovecha la infraestructura de AWS en todo el mundo, protegiendo
                                    recursos en cualquier regi&oacute;n de AWS.</li>
                                <li>Licenciamiento: Shield Advanced se paga por suscripci&oacute;n mensual m&aacute;s cargos
                                    adicionales basados en el tr&aacute;fico mitigado y los recursos protegidos.</li>
                            </ul>
                        </li>
                        <li>HAProxy
                            <ul>
                                <li>Cobranza: HAProxy es una soluci&oacute;n de c&oacute;digo abierto y gratuita, aunque existen
                                    versiones comerciales (HAProxy Enterprise) que incluyen soporte y caracter&iacute;sticas
                                    adicionales.</li>
                                <li>Limitantes: Al ser un balanceador de carga, requiere configuraciones manuales para mitigar DDoS,
                                    y no est&aacute; dise&ntilde;ado para proteger contra grandes ataques DDoS sin ayuda de hardware
                                    adicional.</li>
                                <li>Presencia en red: HAProxy necesita configurarse en diferentes ubicaciones de red para
                                    proporcionar cobertura en m&uacute;ltiples puntos. Requiere infraestructura distribuida del
                                    cliente.</li>
                                <li>Licenciamiento: La versi&oacute;n de c&oacute;digo abierto es gratuita. HAProxy Enterprise tiene
                                    una tarifa de licencia que incluye soporte y funcionalidades adicionales.</li>
                            </ul>
                        </li>
                        <li>Gatekeeper
                            <ul>
                                <li>Cobranza: La mayor&iacute;a de las soluciones Gatekeeper son personalizadas y sus tarifas
                                    dependen de la escala de la red a proteger y del volumen de tr&aacute;fico.</li>
                                <li>Limitantes: La implementaci&oacute;n de Gatekeeper puede tener limitaciones en cuanto a la
                                    complejidad de los ataques y el volumen de tr&aacute;fico, y suele requerir configuraciones
                                    personalizadas.</li>
                                <li>Presencia en red: Requiere la implementaci&oacute;n de su soluci&oacute;n en los puntos de
                                    presencia del cliente, lo cual implica infraestructura distribuida.</li>
                                <li>Licenciamiento: Generalmente, es un modelo de licencia anual, con precios ajustados seg&uacute;n
                                    las necesidades espec&iacute;ficas de red y tr&aacute;fico.</li>
                            </ul>
                        </li>
                        <li>FastNetMon
                            <ul>
                                <li>Cobranza: FastNetMon es gratuito en su versi&oacute;n de c&oacute;digo abierto y tiene una
                                    versi&oacute;n Pro, de pago, con funcionalidades avanzadas.</li>
                                <li>Limitantes: FastNetMon requiere configuraci&oacute;n espec&iacute;fica y conocimiento
                                    t&eacute;cnico para configurarse como soluci&oacute;n anti-DDoS completa. Tambi&eacute;n puede
                                    limitarse a las capacidades de la red subyacente.</li>
                                <li>Presencia en red: Puede desplegarse en m&uacute;ltiples puntos de la red del cliente para
                                    monitoreo y protecci&oacute;n en tiempo real, pero requiere infraestructura distribuida propia.
                                </li>
                                <li>Licenciamiento: La versi&oacute;n Pro se adquiere bajo licencia, con un costo basado en el
                                    n&uacute;mero de instancias y el soporte deseado.</li>
                            </ul>
                        </li>
                    </ol>
                </p>
                <p>Cada una de estas soluciones tiene modelos de cobro, limitaciones y requisitos de infraestructura
                    espec&iacute;ficos, lo que permite adaptarse a necesidades y presupuestos variados. Se recomienda informarse
                    m&aacute;s detalladamente en el sitio oficial de cada soluci&oacute;n.</p>


            </UseLang>
            <UseLang en>

                <h3 id="relevamiento">Information Gathering</h3>
                <h4 id="consulta"><i>Consultation with experts</i></h4>
                <p>Experts from several organizations were asked the following questions:</p>
                <p>What anti-DDoS solutions are available on the market (paid vs. open source)? Which ones are typically used?</p>
                <p>Which solutions are the most popular in Latin America and the Caribbean (LAC)? If no such solutions are used, what is the reason for this?</p>
                <p>How much does an anti-DDoS solution cost? How much does it cost to operate the solution?</p>
                <p>What is the cost of an attack?</p>
                <p>Additionally, the study covered best practices and DDoS mitigation techniques.</p>

                <h4 id="antiddos"><i>Anti-DDoS solutions available on the market</i></h4>
                <p>There are several anti-DDoS solutions available on the market offered by different providers, some of which are listed below. Selecting the most suitable solution for a specific organization depends on various factors, including budget, required protection level, and existing infrastructure.</p>


                <h5 id="cloudfare">Cloudfare [1]:</h5>
                <p><strong>Description:</strong> Cloudflare is one of the most popular DDoS mitigation solutions. It offers protection against both network and application targeted attacks, with a global infrastructure that disperses malicious traffic.</p>
                <p><strong>Features:</strong> DDoS protection, Content Delivery Network (CDN), Web Application Firewall (WAF), and secure DNS.</p>
                <p><strong>Advantages:</strong> Easy to implement, global scalability, real-time analyses, and cost-effective for websites of all sizes.</p>
                <p><i>Key functionalities and detection types</i>
                    <ul>
                        <li>Detects and mitigates DDoS attacks across multiple levels, including the network level (volumetric attacks), transport level (e.g. SYN Floods), and application level (HTTP/S attacks).</li>
                        <li>Blocks malicious traffic, bots, and Layer 7 threats to protect websites and APIs.</li>
                        <li>Offers a Web Application Firewall (WAF) service that detects and blocks attack patterns, such as SQL injections and cross-site scripting (XSS).</li>
                    </ul>
                </p>


                <h5 id="akamai">Akamai:</h5>
                <p><strong>Description:</strong> Akamai is best known for its content delivery network, but also offers robust DDoS mitigation capabilities through its Kona Site Defender service.</p>
                <p><strong>Features:</strong> Network and application protection, traffic distribution across a global network, and advanced monitoring and analysis tools.</p>
                <p><strong>Advantages:</strong> Large distribution network, support for large traffic volumes, and high reliability.</p>
                <p><i>Key functionalities and detection types</i>
                    <ul>
                        <li>Detects and mitigates large-scale, low-latency DDoS attacks, with a focus on network and application-level attacks.</li>
                        <li>Protects against volumetric attacks, resource exhaustion attacks, and application-layer attacks with the potential to disrupt availability.</li>
                        <li>Uses a global distributed network system to detect attack patterns and filter malicious traffic before it reaches its destination servers.</li>
                    </ul>
                </p>
                <p><a href="https://www.akamai.com/" target="_blank" rel="noreferrer">https://www.akamai.com/</a></p>


                <h5 id="aws">Amazon Web Services (AWS) Shield:</h5>
                <p><strong>Description:</strong> AWS Shield is a DDoS mitigation solution built into the AWS infrastructure. Two tiers of AWS Shield are available: Standard and Advanced</p>
                <p><strong>Features:</strong> Protection against network and application targeted attacks, integration with other AWS services, and advanced monitoring and response capabilities.</p>
                <p><strong>Advantages:</strong> Native integration with AWS, automatic protection and scalability, detailed reporting options, and additional support with AWS Shield Advanced.</p>
                <p><i>Key functionalities and detection types</i>
                    <ul>
                        <li>Detects and mitigates Layer 3 (network) and Layer 4 (transport) DDoS attacks, as well as some Layer 7 (application) attacks</li>
                        <li>AWS offers two tiers: Shield Standard (basic protection included for all AWS customers) and Shield Advanced (higher levels of protection against more sophisticated attacks). Shield Advanced integrates with other AWS services for increased visibility and enhanced security incident response</li>
                    </ul>
                </p>
                <p><a href="https://aws.amazon.com/es/shield/" target="_blank" rel="noreferrer">https://aws.amazon.com/es/shield/</a></p>


                <h5 id="google">Google Cloud Armor:</h5>
                <p><strong>Description:</strong> Google Cloud Armor provides DDoS protection for applications hosted on Google Cloud, using Google's global infrastructure.</p>
                <p><strong>Features:</strong> Rules-based security policies, mitigation of network and application targeted attacks, and protection against volumetric and application attacks.</p>
                <p><strong>Advantages:</strong> Native integration with Google Cloud, easy to configure and manage, global scalability.</p>
                <p><i>Key functionalities and detection types</i>
                    <ul>
                        <li>Protects against DDoS attacks and other threats specific to applications hosted on Google Cloud.</li>
                        <li>Includes a WAF that detects and blocks Layer 7 attacks such as SQLi and XSS.</li>
                        <li>Uses artificial intelligence and machine learning to identify anomalous traffic patterns and distinguish between malicious and legitimate traffic.</li>
                    </ul>
                </p>
                <p><a href="https://cloud.google.com/armor/docs?hl=es-419" target="_blank" rel="noreferrer">https://cloud.google.com/armor/docs?hl=es-419</a></p>


                <h5 id="imperva">Imperva Incapsula:</h5>
                <p><strong>Description:</strong> Imperva Incapsula offers DDoS protection for web applications and cloud-based services.</p>
                <p><strong>Features:</strong> Mitigation of network and application targeted DDoS attacks, WAF, bot protection, and real-time monitoring and analysis capabilities.</p>
                <p><strong>Advantages:</strong> Comprehensive protection against various types of attacks, easy to implement, advanced configuration and customization options.</p>
                <p><i>Key functionalities and detection types</i>
                    <ul>
                        <li>Protects web applications against DoS attacks, application layer (Layer 7) attacks, and malicious traffic in general.</li>
                        <li>Incorporates bot protection and advanced WAF to mitigate threats such as injections and unauthorized access.</li>
                        <li>Employs a global server network to detect attacks and scrub traffic before it reaches protected applications.</li>
                    </ul>
                </p>
                <p><a href="https://www.imperva.com/" target="_blank" rel="noreferrer">https://www.imperva.com/</a></p>


                <h5 id="arbor">Arbor Networks (NETSCOUT):</h5>
                <p><strong>Description:</strong> Arbor Networks is a security solution focusing on DDoS protection, used by both service providers and companies.</p>
                <p><strong>Features:</strong> Real-time attack detection and mitigation, global network-based intelligence, and detailed analyses.</p>
                <p><strong>Advantages:</strong> Extensive experience and reputation in DDoS mitigation, support for large infrastructures, and advanced analysis tools.</p>
                <p><i>Key functionalities and detection types</i>
                    <ul>
                        <li>Specializes in the detection and mitigation of large-scale volumetric DDoS attacks and application attacks targeting enterprises and service providers.</li>
                        <li>Uses real-time threat intelligence to quickly respond to attack patterns and divert unwanted traffic.</li>
                        <li>Integrates advanced analytics and real-time traffic visibility to mitigate network threats and improve incident response.</li>
                    </ul>
                </p>
                <p><a href="https://www.netscout.com/solutions/service-provider-ddos-protection" target="_blank" rel="noreferrer">https://www.netscout.com/solutions/service-provider-ddos-protection</a></p>


                <h5 id="f5n">F5 Networks:</h5>
                <p><strong>Description:</strong> F5 Networks provides DDoS mitigation solutions designed to protect applications and networks through its BIG-IP system</p>
                <p><strong>Features:</strong> Mitigation of network and application DDoS attacks, WAF, load balancing, monitoring and analysis tools.</p>
                <p><strong>Advantages:</strong> Hybrid hardware and software approach, high reliability, and ability to handle large volumes of traffic.</p>
                <p><i>Key functionalities and detection types</i>
                    <ul>
                        <li>Offers protection against DDoS attacks, Web Application Firewall (WAF), and bot mitigation for cloud and on-premises environments.</li>
                        <li>Detects application, network, and transport layer attacks, as well as volumetric attacks.</li>
                        <li>The Silverline platform offers managed analysis and response to block attacks in real time and adapts to emerging attack patterns.</li>
                    </ul>
                </p>
                <p><a href="https://www.f5.com/es_es" target="_blank" rel="noreferrer">https://www.f5.com/es_es</a></p>



                <table className="table">
                    <thead>
                        <tr>
                            <th>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                            </th>
                            <th>
                                <p><strong>Cloudflare</strong></p>
                            </th>
                            <th>
                                <p><strong>Akamai Prolexic</strong></p>
                            </th>
                            <th>
                                <p><strong>AWS Shield</strong></p>
                            </th>
                            <th>
                                <p><strong>Google Cloud Armor</strong></p>
                            </th>
                            <th>
                                <p><strong>Imperva Incapsula</strong></p>
                            </th>
                            <th>
                                <p><strong>Arbor Networks (NETSCOUT)</strong></p>
                            </th>
                            <th>
                                <p><strong>F5 Networks (Silverline)</strong></p>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>
                                <p><strong>Network layer protection (L3/L4)</strong></p>
                            </th>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Limited to GCP services</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Application layer protection (L7)</strong></p>
                            </th>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Only whith <em>Shield Advanced</em></p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Real-time mitigation</strong></p>
                            </th>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes (with <em>Shield Advanced</em>)</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Automatic scalability</strong></p>
                            </th>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Limited</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Rules customization</strong></p>
                            </th>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Limited (requires separate WAF)</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Real-time monitoring and alerts</strong></p>
                            </th>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes (in Shield Advanced)</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Always-on protection</strong></p>
                            </th>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes (Shield Advanced)</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Content Distribution Network (CDN)</strong></p>
                            </th>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes (width CloudFront)</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                            <td>
                                <p>Limited</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>DNS protection</strong></p>
                            </th>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Detailed attack reporting</strong></p>
                            </th>
                            <td>
                                <p>Limited</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Only width <em>Shield Advanced</em></p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>24/7 response support</strong></p>
                            </th>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Only in <em>Shield Advanced</em></p>
                            </td>
                            <td>
                                <p>Limited</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                            <td>
                                <p>Yes</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Implementation options</strong></p>
                            </th>
                            <td>
                                <p>Cloud (CDN)</p>
                            </td>
                            <td>
                                <p>Cloud (CDN)</p>
                            </td>
                            <td>
                                <p>Integrated in AWS</p>
                            </td>
                            <td>
                                <p>Integrated in Google Cloud</p>
                            </td>
                            <td>
                                <p>Cloud (CDN)</p>
                            </td>
                            <td>
                                <p>Hybrid (Cloud + On-Premises)</p>
                            </td>
                            <td>
                                <p>Cloud</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Cost</strong></p>
                            </th>
                            <td>
                                <p>Free and premium plans</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Standard (free); Advanced (premium)</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                        </tr>
                    </tbody>
                </table>


                <p>The solutions mentioned above are popular due to their effectiveness and ability to handle large volumes of traffic, as well as to their ease of installation and use. Choosing the right tool depends on factors such as infrastructure, budget, and the organization's specific protection needs.</p>
                <p>In addition to the tools presented in this document, other solutions are available on the market. Organizations should check with security solution providers, as well as with their ISPs, who often offer DDoS mitigation as part of their connectivity service.</p>
                <p>The website <a href="https://www.gartner.com/reviews/market/ddos-mitigation-solutions" target="_blank" rel="noreferrer">https://www.gartner.com/reviews/market/ddos-mitigation-solutions</a> provides a ranking of preferred commercial DDoS mitigation tools, which can be analyzed by region. This ranking is based on user reviews and ratings. Although not all tools have been rated by the same number of users, this information can be taken into account when considering their adoption.</p>
                <p>The table below shows how the tools described in the previous section are ranked for the region of Latin America (in order of the number of reviews and their rating).</p>


                <table className="table">
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Number of reviews</th>
                            <th>Rating (on a scale from 0 to 5)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Cloudfare DDoS Protection</td>
                            <td>18</td>
                            <td>4.6</td>
                        </tr>
                        <tr>
                            <td>Imperva DDoS Protection</td>
                            <td>9</td>
                            <td>4.8</td>
                        </tr>
                        <tr>
                            <td>Akamai Edge DNS</td>
                            <td>3</td>
                            <td>4.7</td>
                        </tr>
                        <tr>
                            <td>Arbor Cloud</td>
                            <td>2</td>
                            <td>5</td>
                        </tr>
                        <tr>
                            <td>Amazon Web Services (AWS) Shield</td>
                            <td>1</td>
                            <td>5</td>
                        </tr>
                    </tbody>
                </table>

                <p>Google Cloud Armor and F5 Networks are not included in the table as they have not been rated on the Gartner website. Gartner also provides rankings based on the size and type of organization.</p>

                <p>Similarly, there are also several open-source tools that can be used for DDOS attack mitigation. Examples include:</p>


                <h5 id="hap">Haproxy:</h5>
                <p><strong>Description:</strong> HAProxy is a free, very fast, and reliable reverse-proxy offering high availability, load balancing, and proxying for TCP and HTTP-based applications.</p>
                <p><strong>Features:</strong> Load balancer and proxy that can help distribute traffic evenly across multiple servers.</p>
                <p><strong>Advantages:</strong> Can be useful for handling large volumes of traffic during a DDoS attack.</p>
                <p><a href="https://github.com/haproxy" target="_blank" rel="noreferrer">https://github.com/haproxy</a></p>


                <h5 id="gate">Gatekeeper:</h5>
                <p><strong>Description:</strong> Gatekeeper was the first open-source DDoS protection system, used by network operators working for institutions, service and content providers, and enterprise networks, among others.</p>
                <p><strong>Features:</strong> Designed to scale to any peak bandwidth. Its architecture is geographically distributed, with a centralized network policy describing all decisions that must be enforced on incoming traffic.</p>
                <p><strong>Advantages:</strong> Its ability to scale to any bandwidth allows it to withstand current and future DDoS attacks. Its centralized policy allows network operators to leverage distributed algorithms that would not be viable under very high latency (e.g. distributed databases) and to fight multiple multi-vector DDoS attacks at once.</p>
                <p><a href="https://github.com/AltraMayor/gatekeeper" target="_blank" rel="noreferrer">https://github.com/AltraMayor/gatekeeper</a></p>


                <h5 id="fast">FastNetMon:</h5>
                <p><strong>Description:</strong> High-performance DDoS detector/sensor built on top of multiple packet capture engines: NetFlow, IPFIX, sFlow, AF_PACKET.</p>
                <p><strong>Features:</strong> Detects hosts sending or receiving large volumes of traffic, packets/bytes/flows per second and performs a configurable action to handle the event. These configurable actions include notifications, calling a script, or making BGP announcements.</p>
                <p><strong>Advantages:</strong> It has multiple advantages, such as the fact that it can detect DoS/DDoS attacks in as little as 1-2 seconds, it scales up to terabits on a single server (sFlow, Netflow, IPFIX) or to 40G+ in mirror mode, thresholds can be configured per subnet, email notifications on detected attacks, and full IPv6 support.</p>
                <p><a href="https://github.com/pavel-odintsov/fastnetmon/" target="_blank" rel="noreferrer">https://github.com/pavel-odintsov/fastnetmon/</a></p>


                <p>Now that we have described a series of both commercial and open-source tools, it is also worth noting that some ISPs and security providers also offer DDoS scrubbing services. These services send the organization clean traffic after absorbing an attack, as they are supposed to have the intelligence to detect and discard most types of DDoS attacks. To ensure effectiveness, they should be complemented with DNS and BGP solutions.</p>


                <h4 id="uso">Use of anti-DDoS solutions</h4>
                <p>Among the tools available on the market and described in the first part of this study, <strong>Cloudflare, Akamai, Amazon Web Services (AWS) Shield, Google Cloud Armor, Imperva Incapsula, Arbor Networks (NETSCOUT),</strong> and <strong>F5 Networks</strong> are generally the most popular or most highly rated. Similarly, <strong>Haproxy, Gatekeeper,</strong> and <strong>FastNetMon</strong> are among the most popular open-source options available.</p>
                <p>To gain first-hand insights into the use of DDoS mitigation solutions in Latin America and the Caribbean, a group of organizations was interviewed. Findings were as follows:</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_1.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>70% of respondents reported having implemented an anti-DDoS solution, while 30% had not yet implemented any.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_2.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>That 70% of respondents had implemented the following solutions:</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_3.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>To understand the reasons why anti-DDoS solutions are not being used, we asked the organizations whether they considered them necessary and, if so, what difficulties were preventing or delaying their implementation. In this regard, we observed that every organization we interviewed considered DDoS attacks in their risk analyses. Additionally, 50% replied they had experienced one or more incidents in the previous six months; 20% of these incidents involved DDoS attacks.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_4.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>This allows us to conclude that these organizations not only analyze this risk, but that in some cases the threat has materialized. Therefore, organizations with no anti-DDoS solution are very unprotected.</p>
                <p>Furthermore, while 30% of organizations do not use anti-DDoS tools, the vast majority do have a procedure or protocol for responding in the event of an attack (80%) or intend to implement one in the future (20%).</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_5.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>This suggests the need to have a tool or solution to support this protocol and can be used to mitigate this type of attack, a conclusion backed by feedback from the organizations themselves. Those without anti-DDoS solutions expressed strong interest in obtaining a solution for mitigating these attacks.</p>
                <p>So, why have some organizations still not adopted an anti-DDoS solution? The reasons they mentioned include:
                    <ul>
                        <li>High cost of the solutions (40%)</li>
                        <li>Other security services are being prioritized (40%)</li>
                        <li>They are in the development or pilot implementation phase (20%)</li>
                    </ul>
                </p>


                <h4 id="costoa">Anti-DDoS solution acquisition and operation costs</h4>
                <p>The costs associated with acquiring the different solutions, their variants, and operation can vary considerably depending on several factors, including the size of the organization, the required level of protection, the level of support provided, the service provider, and the type of solution (cloud-based, on-premises, hybrid, custom, etc.).</p>
                <p>Calculating these costs can be quite complex. In other words, the same solution can and often will have different acquisition and operational costs, making it practically impossible to say that solution X costs Y dollars, for instance. Furthermore, while a thousand dollars may be a very small amount for one organization, it may be considered a significant expense for another.</p>
                <p>For this reason and in order to obtain comparable results, the acquisition and operating costs of the various solutions were calculated based on the monthly budget and operating costs of each organization's security or IT department.</p>
                <p>That said, based on the information provided by the organizations we interviewed, we observed that many (nearly 43%) are either unaware of the costs of acquiring or leasing anti-DDoS solutions or lack this information due to the limitations of their role within the organization.</p>
                <p>For approximately 43% of organizations with an anti-DDoS solution, the estimated cost represents between 1% and 20% of the average operating budget of their CSIRT or IT department, which is a significant portion. For just over 14%, this cost represents between 21% and 50%.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_6.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Likewise, 57% of organizations assign between 1% and 10% of the monthly operating budget of their security/IT department to the operation of the anti-DDoS solution. Others may invest as much as 41% to 50% of the department’s monthly operating budget.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_7.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />


                <h4 id="costoat">Cost of the attacks</h4>
                <p>Due to the diversity of organization types and sizes, as well as their technical and economic capabilities, estimating the cost of a DDoS attack is as complex as calculating the expenses associated with acquiring and operating an anti-DDoS solution.</p>
                <p>This is why organizations that reported having experienced an incident were also asked to estimate the cost associated with an attack relative to their average monthly production value.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_8.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>It should be noted that those who replied “Don't know/Not applicable” are multi-tenant organizations that did not experience the incident directly (it affected one of their member organizations). This is why they may not necessarily be aware of certain details (such as the financial implications). In any case, the economic cost is significant when compared to the average monthly production value of the organization.</p>
                <p>Most organizations that replied to this question are part of the academic sector (universities or NRENs) and at least one of them serves various organizations in the banking, insurance, financial, commercial, and government sectors.</p>
                <p>Additionally, we inquired about other non-tangible costs associated with the incident, from which we gathered the following insights:</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_9.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>It is clear that there are always additional impacts that cannot be economically quantified or at least not easily estimated in monetary terms. Depending on the sector in which they occur, some of these can be even more significant. For example, the damage to a bank's image or reputation can be catastrophic, as it is very easy for customers to lose trust and withdraw their funds from the institution.</p>
                <p>As for the cost of DDOS attacks, in addition to the findings of our interviews, <a href="https://pulse.internetsociety.org/netloss" target="_blank" rel="noreferrer">https://pulse.internetsociety.org/netloss</a> provides a calculator that shows how much an Internet shutdown or service blocking costs a country’s economy. This calculator uses an economic framework to estimate the impact of Internet shutdowns on a range of economic, social, and other outcomes and uses econometric tools to provide a rigorous and precise estimate of the economic impact of a given shutdown. The methodology relies on open publicly available datasets, which makes the methodology reproducible as well as <a href="https://pulse.internetsociety.org/wp-content/uploads/2023/06/Methodology_Internet-Society-Pulse-NetLoss-Calculator_June-2023.pdf" target="_blank" rel="noreferrer"> transparent</a>.</p>
                <p>Internet shutdown and service blocking, calculated for a 24-hour shutdown (date: 7/31/2024 to 8/1/2024).</p>





                <table className="table">
                    <thead>
                        <tr>
                            <th>
                                &nbsp;
                            </th>
                            <th colspan="3">
                                Internet shutdown
                            </th>
                            <th colspan="3">
                                Service blocking
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <p>Country</p>
                            </td>
                            <td>
                                <p>Loss of gross domestic product or purchasing power parity (in USD)</p>
                            </td>
                            <td>
                                <p>Likelihood of experiencing an internet outage in a given year (percentage)</p>
                            </td>
                            <td>
                                <p>Loss of foreign investment (in USD)</p>
                            </td>
                            <td>
                                <p>Loss of gross domestic product or purchasing power parity (in USD)</p>
                            </td>
                            <td>
                                <p>Likelihood of experiencing an internet outage in a given year (percentage)</p>
                            </td>
                            <td>
                                <p>Loss of foreign investment (in USD)</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>ARGENTINA</p>
                            </td>
                            <td>
                                <p>USD $13,245,621</p>
                            </td>
                            <td>
                                <p>2.92 %</p>
                            </td>
                            <td>
                                <p>27</p>
                            </td>
                            <td>
                                <p>USD $1,766,083</p>
                            </td>
                            <td>
                                <p>2.92 %</p>
                            </td>
                            <td>
                                <p>3</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>ARUBA</p>
                            </td>
                            <td>
                                <p>USD $47,507</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>no data</p>
                            </td>
                            <td>
                                <p>USD $6,334</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>no data</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>BELIZE</p>
                            </td>
                            <td>
                                <p>USD $53,102</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>no data</p>
                            </td>
                            <td>
                                <p>USD $7,080</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>no data</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>BOLIVIA</p>
                            </td>
                            <td>
                                <p>USD $1,234,840</p>
                            </td>
                            <td>
                                <p>2.98 %</p>
                            </td>
                            <td>
                                <p>2</p>
                            </td>
                            <td>
                                <p>USD $164,645</p>
                            </td>
                            <td>
                                <p>2.98 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>BRAZIL</p>
                            </td>
                            <td>
                                <p>USD $ 41,208,368</p>
                            </td>
                            <td>
                                <p>2.72 %</p>
                            </td>
                            <td>
                                <p>253</p>
                            </td>
                            <td>
                                <p>USD $5,494,449</p>
                            </td>
                            <td>
                                <p>2.72 %</p>
                            </td>
                            <td>
                                <p>33</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>CHILE</p>
                            </td>
                            <td>
                                <p>USD $ 6,109,129</p>
                            </td>
                            <td>
                                <p>3.59 %</p>
                            </td>
                            <td>
                                <p>18</p>
                            </td>
                            <td>
                                <p>USD $814,551</p>
                            </td>
                            <td>
                                <p>3.59 %</p>
                            </td>
                            <td>
                                <p>2</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>COLOMBIA</p>
                            </td>
                            <td>
                                <p>USD $10,776,131</p>
                            </td>
                            <td>
                                <p>0%</p>
                            </td>
                            <td>
                                <p>78</p>
                            </td>
                            <td>
                                <p>USD $1,436,817</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>10</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>COSTA RICA</p>
                            </td>
                            <td>
                                <p>USD $1,338,233</p>
                            </td>
                            <td>
                                <p>3.03 %</p>
                            </td>
                            <td>
                                <p>8</p>
                            </td>
                            <td>
                                <p>USD $178,431</p>
                            </td>
                            <td>
                                <p>3.03 %</p>
                            </td>
                            <td>
                                <p>1</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>CUBA</p>
                            </td>
                            <td colspan="6">
                                <p>no data</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>REP&Uacute;BLICA DOMINICANA</p>
                            </td>
                            <td>
                                <p>USD $2,699,137</p>
                            </td>
                            <td>
                                <p>3.49 %</p>
                            </td>
                            <td>
                                <p>4</p>
                            </td>
                            <td>
                                <p>USD $359,885</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>ECUADOR</p>
                            </td>
                            <td>
                                <p>USD $2,684,813</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>3</p>
                            </td>
                            <td>
                                <p>USD $357,975</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>EL SALVADOR</p>
                            </td>
                            <td>
                                <p>USD $734,144</p>
                            </td>
                            <td>
                                <p>4.01 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $97,886</p>
                            </td>
                            <td>
                                <p>4.01 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>FRENCH GUIANA</p>
                            </td>
                            <td>
                                <p>USD $321,851</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>1</p>
                            </td>
                            <td>
                                <p>USD $42,914</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>GUATEMALA</p>
                            </td>
                            <td>
                                <p>USD $2,277,611</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>1</p>
                            </td>
                            <td>
                                <p>USD $303,681</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>GUYANA</p>
                            </td>
                            <td>
                                <p>USD $321,851</p>
                            </td>
                            <td>
                                <p>0%</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $42,914</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>HAIT&Iacute;</p>
                            </td>
                            <td>
                                <p>USD $370,249</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>30</p>
                            </td>
                            <td>
                                <p>USD $49,367</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>4</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>HONDURAS</p>
                            </td>
                            <td>
                                <p>2.71 %</p>
                                <p>&nbsp;</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>6</p>
                            </td>
                            <td>
                                <p>USD $93,600</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>MEXICO</p>
                            </td>
                            <td>
                                <p>USD $30,013,923</p>
                            </td>
                            <td>
                                <p>2.71 %</p>
                                <p>&nbsp;</p>
                            </td>
                            <td>
                                <p>16</p>
                            </td>
                            <td>
                                <p>USD $4,001,856</p>
                            </td>
                            <td>
                                <p>2.71 %</p>
                                <p>&nbsp;</p>
                            </td>
                            <td>
                                <p>12</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>NETHERLAND ANTILLES</p>
                            </td>
                            <td>
                                <p>USD $19,526</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $2,603</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>NICARAGUA</p>
                            </td>
                            <td>
                                <p>USD $515,952</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>2</p>
                            </td>
                            <td>
                                <p>USD $68,794</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>PANAM&Aacute;</p>
                            </td>
                            <td>
                                <p>USD $1,573,209</p>
                            </td>
                            <td>
                                <p>2.74 %</p>
                            </td>
                            <td>
                                <p>3</p>
                            </td>
                            <td>
                                <p>USD $209,761</p>
                            </td>
                            <td>
                                <p>2.74 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>PARAGUAY</p>
                            </td>
                            <td>
                                <p>USD $1,089,434</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>4</p>
                            </td>
                            <td>
                                <p>USD $145,258</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>PERU</p>
                            </td>
                            <td>
                                <p>USD $5,496,941</p>
                            </td>
                            <td>
                                <p>3.02 %</p>
                            </td>
                            <td>
                                <p>7</p>
                            </td>
                            <td>
                                <p>USD $732,925</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>3.02 %</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>SURINAME</p>
                            </td>
                            <td>
                                <p>USD $122,327</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $16,310</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>TRINIDAD AND TOBAGO</p>
                            </td>
                            <td>
                                <p>USD $451,804</p>
                            </td>
                            <td>
                                <p>2.52 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $60,241</p>
                            </td>
                            <td>
                                <p>2.52 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>URUGUAY</p>
                            </td>
                            <td>
                                <p>USD $1,105,827</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $147,444</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                    </tbody>
                </table>


                <h4 id="esquema">Payment and licensing schemes</h4>
                <p>Additionally, we studied the pricing models, limitations, and network presence options for each of the anti-DDoS solutions we discussed. Findings are included below:
                    <ol>
                        <li>Cloudflare DDoS Protection
                            <ul>
                                <li>Pricing: Cloudflare offers different plans, from free options for small websites to advanced enterprise solutions. Advanced DDoS protection is part of the paid plans and is included in Cloudflare Business and Enterprise.</li>
                                <li>Limitations: Free plans may offer limited mitigation and do not include custom protection against specific attacks. Various paid plans have different limitations.</li>
                                <li>Network precense: Cloudflare has a global infrastructure that allows protecting websites worldwide without additional configuration.</li>
                                <li>Licensing: Advanced plans are typically monthly or annual subscription plans, and some enterprise services may be subject to custom rates based on utilization and mitigation needs.</li>
                            </ul>
                        </li>
                        <li>Imperva DDoS Protection
                            <ul>
                                <li>Pricing: Imperva charges based on traffic and the complexity of the protection required. It offers custom pricing for businesses with high traffic and specific requirements.</li>
                                <li>Limitations: Some entry-level plans have limited customization capacity and may not include all layers of protection.</li>
                                <li>Network precense: Uses globally distributed mitigation centers, allowing attacks to be managed across multiple regions without additional infrastructure.</li>
                                <li>Licensing: Subscription-based and, in some cases, fees based on monthly traffic volume. Plans are typically annual and adjusted as needed.</li>
                            </ul>
                        </li>
                        <li>Akamai Edge DNS
                            <ul>
                                <li>Pricing: Akamai charges primarily based on DNS traffic and service level. Rates can vary significantly, with customized pricing for larger enterprises.</li>
                                <li>Limitations: Some entry-level plans may not include all layers of protection or full access to the global mitigation network.</li>
                                <li>Network precense: Thanks to its global network, Akamai allows DNS-level mitigation across multiple locations. This service is designed to protect against distributed attacks without additional local intervention.</li>
                                <li>Licensing: Typically, a monthly or annual subscription model; pricing can scale based on the volume of traffic that is handled.</li>
                            </ul>
                        </li>
                        <li>Arbor Cloud
                            <ul>
                                <li>Pricing: Arbor Cloud charges based on the volume of traffic to be mitigated and the contracted capacities (e.g., mitigation speed). This solution can be expensive for high-traffic networks.</li>
                                <li>Limitations: There are limits on the traffic that each plan can manage. Configuration and analysis also require specialized resources.</li>
                                <li>Network precense: Arbor Cloud integrates with distributed datacenter networks and has a global mitigation infrastructure.</li>
                                <li>Licensing: Typically, an annual or monthly subscription model; some specific services may be billed separately as add-ons.</li>
                            </ul>
                        </li>
                        <li>Amazon Web Services (AWS) Shield
                            <ul>
                                <li>Pricing: AWS Shield Standard is free for AWS users. Shield Advanced is priced based on the volume of traffic mitigated and the protected infrastructure.</li>
                                <li>Limitations: Shield Standard has limitations in terms of the type and volume of attacks it can mitigate. Shield Advanced has adjustable limits based on configuration and traffic volume.</li>
                                <li>Network precense: AWS Shield leverages AWS infrastructure worldwide, protecting resources in any of the AWS regions.</li>
                                <li>Licensing: Shield Advanced is typically billed as a monthly subscription plus additional charges based on mitigated traffic and protected resources.</li>
                            </ul>
                        </li>
                        <li>HAProxy
                            <ul>
                                <li>Pricing: HAProxy is a free and open-source solution. However, some commercial versions (HAProxy Enterprise) include support and additional features.</li>
                                <li>Limitations: Because it is a load balancer, HAProxy requires manual configuration to mitigate DDoS attacks. Also, it is not designed to protect against large DDoS attacks without the help of additional hardware.</li>
                                <li>Network precense: HAProxy must be configured in different network locations to provide coverage at multiple points. Requires distributed customer infrastructure.</li>
                                <li>Licensing: The open-source version is free. HAProxy Enterprise has a licensing fee that includes support and additional features.</li>
                            </ul>
                        </li>
                        <li>Gatekeeper
                            <ul>
                                <li>Pricing: Most Gatekeeper solutions are customized, and their fees depend on the scale of the network to be protected and the volume of traffic.</li>
                                <li>Limitations: Gatekeeper implementations may have limitations in terms of the attack complexity and traffic volume they can handle, and often require custom configuration.</li>
                                <li>Network precense: Requires the solution to be implemented at the customer's points of presence, i.e., distributed infrastructure.</li>
                                <li>Licensing: Typically, an annual licensing model, with pricing adjusted based on specific network and traffic needs.</li>
                            </ul>
                        </li>
                        <li>FastNetMon
                            <ul>
                                <li>Pricing: FastNetMon offers a free open-source version, as well as a paid Pro version with advanced features.</li>
                                <li>Limitations: FastNetMon requires specific settings and technical knowledge to be used as a complete anti-DDoS solution. It may also be limited to the capabilities of the underlying network.</li>
                                <li>Network precense: Can be deployed at multiple points in the customer's network for real-time monitoring and protection but requires its own distributed infrastructure.</li>
                                <li>Licensing: The Pro version requires purchasing a license, the cost of which depends on the number of instances and desired support.</li>
                            </ul>
                        </li>
                    </ol>
                </p>
                <p>Each of these solutions has specific pricing models, limitations, and infrastructure requirements, so they can be adapted to various needs and budgets. Readers are advised to visit the official website of each solution for more detailed information.</p>

            </UseLang>
            <UseLang pt>

                <h3 id="relevamiento">Enquete</h3>
                <h4 id="consulta"><i>Consulta com especialistas</i></h4>
                <p>Especialistas de diversas organizações foram consultados e questionados sobre os seguintes assuntos:</p>
                <p>Quais são as soluções anti-DDoS existentes no mercado (pagas vs. código aberto)? Quais são usadas em geral?</p>
                <p>Quais são as soluções mais usadas na América Latina e o Caribe (ALC)? Se não forem usadas, qual é o motivo?</p>
                <p>Quanto custa uma solução? Quanto custa sua operação?</p>
                <p>Quanto custa um ataque?</p>
                <p>Além disso, foram pesquisadas as boas práticas e técnicas de mitigação de DDoS.</p>

                <h4 id="antiddos"><i>Soluções anti-DDoS no mercado</i></h4>
                <p>Existem diversas soluções anti-DDoS no mercado, oferecidas por diferentes fornecedores. As listadas abaixo são algumas das disponíveis. A escolha da melhor solução para uma organização depende de vários fatores, como o orçamento, o nível de proteção requerido e a infraestrutura.</p>


                <h5 id="cloudfare">Cloudfare [1]:</h5>
                <p><strong>Descrição:</strong> Cloudflare é uma das soluções mais populares para a mitigação de DDoS. Oferece proteção na rede e aplicação, com uma infraestrutura global que dispersa o tráfego malicioso.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Proteção DDoS, CDN (Content Delivery Network), WAF (Web Application Firewall) e DNS seguro.</p>
                <p><strong>Vantagens:</strong> Fácil de implementar, escalabilidade global, análise em tempo real, e rentável para sites de todos os tamanhos.</p>
                <p><i>Funcionalidades mais relevantes e tipos de detecção que implementa</i>
                    <ul>
                        <li>Detecta e mitiga ataques DDoS na rede (volumétricos), nível de transporte (como SYN Floods) e nível de aplicação (ataques HTTP/S).</li>
                        <li>Bloqueia tráfego malicioso, bots indesejados e ameaças da camada 7 para proteger sites e API.</li>
                        <li>Oferece Web Application Firewall (WAF) que detecta e bloqueia padrões de ataque, como injeções de SQL e cross-site scripting (XSS).</li>
                    </ul>
                </p>


                <h5 id="akamai">Akamai:</h5>
                <p><strong>Descrição:</strong> Akamai es conocido por su red de entrega de contenido aunque tambi&eacute;n ofrece robustas capacidades de mitigaci&oacute;n de DDoS a trav&eacute;s de su servicio Kona Site Defender.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Proteção na rede e aplicação, distribuição de tráfego por meio de uma rede global, e ferramentas avançadas de análise e monitoramento.</p>
                <p><strong>Vantagens:</strong> Ampla rede de distribuição, suporte para grandes volumes de tráfego e alta confiabilidade.</p>
                <p><i>Funcionalidades mais relevantes e tipos de detecção que implementa</i>
                    <ul>
                        <li>Detecta e mitiga ataques DDoS de grande escala e de baixa latência, especializados em ataques na rede e aplicativos.</li>
                        <li>Protege contra ataques volumétricos, ataques de esgotamento de recursos e ataques à camada de aplicação que podem interromper a disponibilidade.</li>
                        <li>Usa um sistema global de rede distribuído para detectar padrões de ataque e filtrar o tráfego malicioso antes que ele chegue aos servidores de destino.</li>
                    </ul>
                </p>
                <p><a href="https://www.akamai.com/" target="_blank" rel="noreferrer">https://www.akamai.com/</a></p>


                <h5 id="aws">Amazon Web Services (AWS) Shield:</h5>
                <p><strong>Descrição:</strong> AWS Shield é uma solução de mitigação de DDoS integrada à infraestrutura de AWS. Disponível em dois níveis: standard e advanced.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Proteção contra ataques em rede e aplicação, integração com outros serviços de AWS e recursos avançados de monitoramento e resposta.</p>
                <p><strong>Vantagens:</strong> Integração nativa com AWS, proteção automática e escalabilidade, opções de relatórios detalhados e suporte adicional com Shield Advanced.</p>
                <p><i>Funcionalidades mais relevantes e tipos de detecção que implementa</i>
                    <ul>
                        <li>Detecta e mitiga ataques DDoS de nível 3 (rede) e nível 4 (transporte), bem como alguns ataques na camada 7 (aplicação).</li>
                        <li>AWS oferece dois níveis: Shield Standard (proteção básica integrada para todos os clientes da AWS) e Shield Advanced (proteção adicional contra ataques mais sofisticados). O Shield Advanced é integrado a outros serviços da AWS para maior visibilidade e resposta a incidentes de segurança.</li>
                    </ul>
                </p>
                <p><a href="https://aws.amazon.com/es/shield/" target="_blank" rel="noreferrer">https://aws.amazon.com/es/shield/</a></p>


                <h5 id="google">Google Cloud Armor:</h5>
                <p><strong>Descrição:</strong> O Google Cloud Armor fornece proteção DDoS para aplicativos hospedados no Google Cloud, usando a infraestrutura global do Google.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Políticas de segurança baseadas em regras, mitigação de ataques na rede e aplicação, proteção contra ataques volumétricos e de aplicação.</p>
                <p><strong>Vantagens:</strong> Integração nativa com Google Cloud, fácil de configurar e gerenciar, escalabilidade global.</p>
                <p><i>Funcionalidades mais relevantes e tipos de detecção que implementa</i>
                    <ul>
                        <li>Fornece proteção contra ataques DDoS e outras ameaças específicas aos aplicativos hospedados no Google Cloud.</li>
                        <li>Inclui um WAF que detecta e bloqueia ataques na camada 7, como SQLi e XSS</li>
                        <li>Usa inteligência artificial e aprendizado de máquina para identificar padrões de tráfego anômalos e diferenciar o tráfego malicioso do tráfego legítimo.</li>
                    </ul>
                </p>
                <p><a href="https://cloud.google.com/armor/docs?hl=es-419" target="_blank" rel="noreferrer">https://cloud.google.com/armor/docs?hl=es-419</a></p>


                <h5 id="imperva">Imperva Incapsula:</h5>
                <p><strong>Descrição:</strong> Imperva Incapsula oferece proteção DDoS para aplicativos web e serviços baseados na nuvem.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Mitigação de DDoS na rede e aplicação, WAF, proteção contra bots, e recursos de monitoramento e análise em tempo real.</p>
                <p><strong>Vantagens:</strong> Proteção abrangente contra vários tipos de ataques, fácil implementação, e opções avançadas de configuração e personalização.</p>
                <p><i>Funcionalidades mais relevantes e tipos de detecção que implementa</i>
                    <ul>
                        <li>Protege aplicativos web contra ataques DDoS, ataques na camada de aplicação (nível 7) e tráfego malicioso em geral.</li>
                        <li>Incorpora proteção contra bots e WAF avançado para mitigar ameaças como injeções e acessos não autorizados.</li>
                        <li>Usa uma rede global de servidores para detectar ataques e limpar o tráfego antes que este atinja os aplicativos protegidos.</li>
                    </ul>
                </p>
                <p><a href="https://www.imperva.com/" target="_blank" rel="noreferrer">https://www.imperva.com/</a></p>


                <h5 id="arbor">Arbor Networks (NETSCOUT):</h5>
                <p><strong>Descrição:</strong> Arbor Networks é uma solução de segurança que oferece proteção contra os ataques DDoS, usada tanto por provedores de serviços quanto por empresas.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Detecção e mitigação de ataques em tempo real, inteligência baseada na rede global, e análises detalhadas.</p>
                <p><strong>Vantagens:</strong> Ampla experiência e reputação em mitigação de DDoS, suporte para grandes infraestruturas e ferramentas avançadas de análise.</p>
                <p><i>Funcionalidades mais relevantes e tipos de detecção que implementa</i>
                    <ul>
                        <li>É especializada na detecção e mitigação de ataques DDoS volumétricos de grande escala e ataques de aplicação direcionados a empresas e provedores de serviços.</li>
                        <li>Usa inteligência contra ameaças em tempo real para responder rapidamente aos padrões de ataque e desviar o tráfego indesejado.</li>
                        <li>Incorpora análises avançadas e visibilidade do tráfego em tempo real para mitigar ameaças à rede e melhorar a resposta perante incidentes.</li>
                    </ul>
                </p>
                <p><a href="https://www.netscout.com/solutions/service-provider-ddos-protection" target="_blank" rel="noreferrer">https://www.netscout.com/solutions/service-provider-ddos-protection</a></p>


                <h5 id="f5n">F5 Networks:</h5>
                <p><strong>Descrição:</strong> A F5 Networks oferece soluções de mitigação de DDoS que protegem aplicativos e redes por meio de seu sistema BIG-IP.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Mitigação de DDoS na rede e aplicação, WAF, balanceamento de carga, e ferramentas de monitoramento e análise.</p>
                <p><strong>Vantagens:</strong> Abordagem híbrida de hardware e software, alta confiabilidade e capacidade de lidar com grandes volumes de tráfego.</p>
                <p><i>Funcionalidades mais relevantes e tipos de detecção que implementa</i>
                    <ul>
                        <li>Oferece proteção contra ataques DDoS, Web Application Firewall (WAF) e mitigação de bots para ambientes locais e na nuvem.</li>
                        <li>Detecta ataques na camada de aplicação, redes e transporte, bem como ataques volumétricos.</li>
                        <li>A plataforma Silverline oferece análises e respostas gerenciadas para bloquear ataques em tempo real e se adaptar aos padrões de ataque emergentes.</li>
                    </ul>
                </p>
                <p><a href="https://www.f5.com/es_es" target="_blank" rel="noreferrer">https://www.f5.com/es_es</a></p>


                <p><strong>Tabela comparativa que resume as principais funcionalidades das soluções descritas</strong></p>

                <table className="table">
                    <thead>
                        <tr>
                            <th> 
                            </th>
                            <th>
                                <p><strong>Cloudflare</strong></p>
                            </th>
                            <th>
                                <p><strong>Akamai Prolexic</strong></p>
                            </th>
                            <th>
                                <p><strong>AWS Shield</strong></p>
                            </th>
                            <th>
                                <p><strong>Google Cloud Armor</strong></p>
                            </th>
                            <th>
                                <p><strong>Imperva Incapsula</strong></p>
                            </th>
                            <th>
                                <p><strong>Arbor Networks (NETSCOUT)</strong></p>
                            </th>
                            <th>
                                <p><strong>F5 Networks (Silverline)</strong></p>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>
                                <p><strong>Proteção da camada de rede (L3/L4)</strong></p>
                            </th>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Limitada a serviços em GCP</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Proteção da camada de aplicação (L7)</strong></p>
                            </th>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Só com <em>Shield Advanced</em></p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Mitigação em tempo real</strong></p>
                            </th>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim (com <em>Shield Advanced</em>)</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Escalabili-dade automática</strong></p>
                            </th>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Limitada</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Personali-zação de regras</strong></p>
                            </th>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Limitado (requer WAF separado)</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Monitora-mento e alertas em tempo real</strong></p>
                            </th>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim (com <em>Shield Advanced</em>)</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Proteção sempre ativa</strong></p>
                            </th>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim (<em>Shield Advanced</em>)</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Rede de distribuição de conteúdo (CDN)</strong></p>
                            </th>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim (com CloudFront)</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                            <td>
                                <p>Limitada</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Proteção do DNS</strong></p>
                            </th>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>No</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Relatório detalhado de ataques</strong></p>
                            </th>
                            <td>
                                <p>Limitado</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Só em <em>Shield Advanced</em></p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Suporte de resposta 24/7</strong></p>
                            </th>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Só em <em>Shield Advanced</em></p>
                            </td>
                            <td>
                                <p>Limitado</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                            <td>
                                <p>Sim</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Opções de implementação</strong></p>
                            </th>
                            <td>
                                <p>Cloud (CDN)</p>
                            </td>
                            <td>
                                <p>Cloud (CDN)</p>
                            </td>
                            <td>
                                <p>Integrado em AWS</p>
                            </td>
                            <td>
                                <p>Integrado em Google Cloud</p>
                            </td>
                            <td>
                                <p>Cloud (CDN)</p>
                            </td>
                            <td>
                                <p>H&iacute;brido (Cloud + On-Premises)</p>
                            </td>
                            <td>
                                <p>Cloud</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><strong>Custo</strong></p>
                            </th>
                            <td>
                                <p>Gratuito e planos premium</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Padrão (grátis); Avançado (premium)</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                            <td>
                                <p>Premium</p>
                            </td>
                        </tr>
                    </tbody>
                </table>



                <p>As ferramentas mencionadas são amplamente usadas devido à sua eficácia e capacidade de lidar com grandes volumes de tráfego, bem como pela sua facilidade de integração e uso. A escolha da ferramenta certa depende de fatores como a infraestrutura, o orçamento e as necessidades específicas de proteção da organização.</p>

                <p>Além das ferramentas apresentadas, existem outras soluções no mercado. As organizações podem consultar fornecedores de soluções de segurança, bem como também a seus ISP, que muitas vezes oferecem serviços de mitigação de DDoS como um valor agregado ao seu serviço de conectividade.</p>
                <p>Em <a href="https://www.gartner.com/reviews/market/ddos-mitigation-solutions" target="_blank" rel="noreferrer">https://www.gartner.com/reviews/market/ddos-mitigation-solutions</a> é estabelecido um ranking de preferência de ferramentas comerciais, que pode ser analisado por região. Esse ranking é elaborado de acordo com a avaliação feita pelos usuários. Embora nem todas as ferramentas sejam valorizadas pelo mesmo número de usuários, estas podem ser levadas em consideração na hora de adotar uma.</p>
                <p>A seguir, é apresentado o ranking para a região da América Latina das ferramentas descritas na seção anterior (ordenado por número de avaliações e pontuação da avaliação).</p>


                <table className="table">
                    <thead>
                        <tr>
                            <th>Produto</th>
                            <th>Número de avaliações</th>
                            <th>Avaliação (escala de 0 a 5)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Cloudfare DDoS Protection</td>
                            <td>18</td>
                            <td>4.6</td>
                        </tr>
                        <tr>
                            <td>Imperva DDoS Protection</td>
                            <td>9</td>
                            <td>4.8</td>
                        </tr>
                        <tr>
                            <td>Akamai Edge DNS</td>
                            <td>3</td>
                            <td>4.7</td>
                        </tr>
                        <tr>
                            <td>Arbor Cloud</td>
                            <td>2</td>
                            <td>5</td>
                        </tr>
                        <tr>
                            <td>Amazon Web Services (AWS) Shield</td>
                            <td>1</td>
                            <td>5</td>
                        </tr>
                    </tbody>
                </table>

                <p>Google Cloud Armor e F5 Networks não estão incluídos na tabela porque não foram avaliados no ranking de Gartner. Além disso, nesse site você também pode consultar o ranking de acordo com o tamanho e tipo de organização.</p>

                <p>Do outro lado, existem também ferramentas de código aberto com o mesmo objetivo de mitigação de ataques de DDoS. Entre elas, vale destacar:</p>


                <h5 id="hap">Haproxy:</h5>
                <p><strong>Descrição:</strong> HAProxy é um proxy inverso gratuito, muito rápido e confiável, que oferece alta disponibilidade, balanceamento de carga e proxy para aplicativos baseados em TCP e HTTP.</p>
                <p><strong>Caracter&iacute;sticas:</strong> É um balanceador de carga e proxy que pode ajudar a distribuir o tráfego de forma equitativa entre vários servidores.</p>
                <p><strong>Vantagens:</strong> Pode ser útil para lidar com grandes volumes de tráfego durante um ataque de DDoS.</p>
                <p><a href="https://github.com/haproxy" target="_blank" rel="noreferrer">https://github.com/haproxy</a></p>


                <h5 id="gate">Gatekeeper:</h5>
                <p><strong>Descrição:</strong> Gatekeeper é o primeiro sistema de proteção DDoS de código aberto, usado por operadores de redes institucionais, provedores de serviços e conteúdo, redes empresariais, etc.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Ele foi projetado para escalar para qualquer largura de banda máxima. Sua arquitetura é geograficamente distribuída e a política de rede que descreve todas as decisões que devem ser aplicadas ao tráfego de entrada é centralizada.</p>
                <p><strong>Vantagens:</strong> Sua capacidade de escalar para qualquer largura de banda faz com que ele possa resistir a ataques DDoS atuais e futuros. Sua política centralizada permite que os operadores de rede aproveitem os algoritmos distribuídos que não seriam viáveis com uma latência muito alta (por exemplo, bases de dados distribuídas) e combater múltiplos ataques DDoS multivectoriais em simultâneo.</p>
                <p><a href="https://github.com/AltraMayor/gatekeeper" target="_blank" rel="noreferrer">https://github.com/AltraMayor/gatekeeper</a></p>


                <h5 id="fast">FastNetMon:</h5>
                <p><strong>Descrição:</strong> Um detector/sensor DDoS de alto desempenho baseado em vários mecanismos de captura de pacotes: NetFlow, IPFIX, sFlow, AF_PACKET.</p>
                <p><strong>Caracter&iacute;sticas:</strong> Detecta hosts na rede que enviam ou recebem grandes volumes de tráfego, pacotes/bytes/fluxos por segundo, e executa uma ação configurável para lidar com esse evento. Estas ações configuráveis incluem notificar, chamar o script ou fazer anúncios BGP.</p>
                <p><strong>Vantagens:</strong> Possui múltiplas vantagens, como detectar DoS/DDoS em apenas um ou dois segundos, escalar até terabits em um único servidor (sFlow, Netflow, IPFIX) ou até 40G+ em modo espelho, permite configurar limites por subrede, tem notificações por e-mail sobre ataques detectados e tem suporte total para o IPv6.</p>
                <p><a href="https://github.com/pavel-odintsov/fastnetmon/" target="_blank" rel="noreferrer">https://github.com/pavel-odintsov/fastnetmon/</a></p>


                <p>Tendo descrito este conjunto de ferramentas, tanto comerciais quanto de código aberto, não devemos deixar de mencionar que alguns ISP ou fornecedores de segurança também oferecem serviços de depuração de DDoS. Estes consistem em enviar tráfego limpo para a organização após absorver o ataque, porque supostamente possuem inteligência para detectar e descartar a maioria dos tipos de ataques DDoS. Esses serviços devem ser complementados com soluções DNS e BGP para serem eficazes.</p>


                <h4 id="uso">Uso de soluções anti-DDoS</h4>
                <p>Das ferramentas oferecidas pelo mercado (cuja descrição foi incluída na parte 1 deste trabalho), a <strong>Cloudflare, Akamai, Amazon Web Services (AWS) Shield, Google Cloud Armor, Imperva Incapsula, Arbor Networks (NETSCOUT)</strong> e <strong>F5 Networks</strong> são as mais usadas/valorizadas em geral. Por sua vez, <strong>Haproxy, Gatekeeper e FastNetMon</strong> se encontram entre as soluções de código aberto disponíveis.</p>
                <p>Para conhecer em primeira mão o que está acontecendo na América Latina e o Caribe em relação ao uso das soluções, foi entrevistado um grupo de organizações desta região, distribuídas da seguinte forma:</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_1.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Quando consultadas sobre se possuem uma solução anti-DDoS, 70% responderam que sim. O restante 30% ainda não implementou nenhuma solução para mitigar os ataques de DDoS.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_2.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Desse 70%, as soluções que implementam são as seguintes:</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_3.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Para avaliar por que as soluções anti-DDoS não são usadas, consultou-se sobre se as organizações as consideravam necessárias e, nos casos afirmativos, sobre as dificuldades que fazem com que não sejam implementadas ou sejam adiadas. A respeito disso, observamos que, em suas análises de risco, todas as organizações entrevistadas consideram os ataques de DDoS. Adicionalmente, 50% delas responderam que sofreram algum incidente nos últimos seis meses; 20% desses incidentes foram ataques de DDoS.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_4.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Podemos inferir que não apenas analisam esse risco, mas que a ameaça se concretizou em alguns casos. Portanto, as organizações que não possuem soluções anti-DDoS ficariam muito desprotegidas.</p>
                <p>Além disso, embora 30% das organizações não possuam ferramentas anti-DDoS, a grande maioria possui um procedimento ou protocolo de ação (80%) ou, pelo menos, planeja incluí-lo (20%).</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_5.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>A partir disso podemos pensar que é necessário ter uma ferramenta ou solução que suporte esse protocolo de ação e que possa ser utilizada para mitigar este tipo de ataques. Isto pode ser afirmado com base no que as próprias organizações declararam. Todas aquelas que não possuem soluções anti-DDoS manifestaram grande interesse em aceder a alguma solução para mitigar estes ataques.</p>
                <p>Então, por que existem organizações que ainda não possuem uma solução anti-DDoS? Os motivos expressos foram:
                    <ul>
                        <li>Alto custo das soluções (40%)</li>
                        <li>Outros serviços de segurança são priorizados para implementação/contratação (40%)</li>
                        <li>Estão em plano de desenvolvimento ou de implementação do plano piloto (20%)</li>
                    </ul>
                </p>


                <h4 id="costoa">Custo de aquisição e operação das soluções anti-DDoS</h4>
                <p>Ao pesquisar sobre os custos das soluções e do seu funcionamento, existem diferentes variantes de produtos e o custo pode variar significativamente dependendo de vários fatores: a dimensão da organização, o nível de proteção exigido, o nível de suporte prestado, o fornecedor do serviço e o tipo de solução (baseada na nuvem, on-premise, híbrida, personalizada, etc.).</p>
                <p>Tudo isso torna a avaliação muito complexa. Quer dizer, uma mesma solução pode e geralmente tem custos de aquisição e operação diferentes, portanto não podemos dizer que a solução X custa Y dólares, por exemplo. Além disso, mil dólares podem ser pouco para uma organização e muito para outra.</p>
                <p>Por este motivo, os custos de aquisição e operação das diferentes soluções foram avaliados com base nos orçamentos e custos operacionais mensais da área de segurança ou TI de cada organização, de forma a obter resultados próximos da realidade de cada uma.</p>
                <p>Dito isto, e com base nas informações fornecidas pelos entrevistados, pudemos observar que muitos (quase 43%) não conhecem os custos de aquisição ou aluguel de soluções anti-DDoS ou não possuem tais informações devido a restrições no seu papel dentro da organização.</p>
                <p>Para cerca de 43% das organizações que possuem solução anti-DDoS, o custo estimado está entre 1% e 20% do valor operacional médio do CSIRT ou área de TI da organização, o que representa um percentual alto. Para pouco mais dos 14% restantes, esse custo está entre 21% e 50%.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_6.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>Além disso, constatou-se que 57% das organizações alocam entre 1% e 10% do orçamento mensal de operação da área de segurança/TI para a operação da solução anti-DDoS. Outras podem até investir entre 41% e 50% do orçamento operacional mensal da área.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_7.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />


                <h4 id="costoat">Custo dos ataques</h4>
                <p>Tal como acontece com os custos de aquisição e operação de uma solução anti-DDoS, o custo de um ataque também é complexo de estimar devido à diversidade de tipos e tamanhos das organizações, bem como de suas capacidades técnicas e econômicas.</p>
                <p>Por este motivo, também foi solicitado às organizações que reportaram ter sofrido um incidente que estimassem o custo associado ao ataque com base no valor médio de produção mensal da organização.</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_8.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>É importante observar que aquelas que responderam “Não sabe/Não aplica” são organizações multi-tenant que não tiveram o incidente diretamente (uma de suas organizações-membro teve). É por isso que existem certos detalhes (como os econômicos) que não estão necessariamente ao seu alcance. De qualquer forma, o custo econômico é significativo em relação ao valor médio da produção mensal da organização.</p>
                <p>A maioria das organizações que responderam a esta questão são da área acadêmica (universidades ou NREN) e pelo menos uma atende diferentes organizações nas áreas bancária, de seguros, do setor financeiro, comercial e governamental.</p>
                <p>Adicionalmente, questionamos sobre outros custos não tangíveis associados ao incidente, perante o qual obtivemos:</p>


                <img src="/images/investigacion-sobre-ataques-ddos/imagen_9.png" className="chart-image" alt="investigacion-sobre-ataques-ddos" />
                <p>É claro que existem sempre outros efeitos que não são economicamente tangíveis ou, pelo menos, não são facilmente estimáveis economicamente. Alguns deles, dependendo do setor onde ocorrem, podem até resultar mais impactantes. Por exemplo, os danos à imagem ou reputação de um banco podem ser catastróficos, uma vez que é muito fácil para as pessoas retirarem os seus ativos da instituição quando perdem a confiança.</p>
                <p>Do outro lado, sobre o custo dos ataques de DDoS – e além dos coletados nas entrevistas— o site <a href="https://pulse.internetsociety.org/netloss" target="_blank" rel="noreferrer">https://pulse.internetsociety.org/netloss</a> oferece uma calculadora que mostra qual é o custo para um país que sofre uma interrupção na Internet ou um bloqueio de conteúdo. Esta calculadora usa um quadro econômico para estimar o impacto da não disponibilidade da Internet ou de conteúdos em uma série de resultados econômicos, sociais e outros, e emprega ferramentas econométricas para fornecer uma estimativa rigorosa e precisa do impacto econômico. A metodologia se baseia em conjuntos de dados abertos para fazer o cálculo, o que determina que a metodologia seja reprodutível e <a href="https://pulse.internetsociety.org/wp-content/uploads/2023/06/Methodology_Internet-Society-Pulse-NetLoss-Calculator_June-2023.pdf" target="_blank" rel="noreferrer"> transparente</a>.</p>
                <p>Por falha na Internet e bloqueio de conteúdo, calculado para 24 horas de interrupção (data: de 31/07/2024 a 01/08/2024).</p>




                <table className="table">
                    <thead>
                        <tr>
                            <th>
                                <p>&nbsp;</p>
                            </th>
                            <th colspan="3">
                                <p>Por falha na Internet</p>
                            </th>
                            <th colspan="3">
                                <p>Por bloqueio de conteúdo</p>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <p>Pa&iacute;s</p>
                            </td>
                            <td>
                                <p>Perda do produto interno bruto ou paridade do poder de compra (em USD)</p>
                            </td>
                            <td>
                                <p>Probabilidade de ocorrer uma falha na Internet em um ano determinado (em porcentagem)</p>
                            </td>
                            <td>
                                <p>Perda de investimento estrangeiro (em USD)</p>
                            </td>
                            <td>
                                <p>Perda do produto interno bruto ou paridade do poder de compra (em USD)</p>
                            </td>
                            <td>
                                <p>Probabilidade de ocorrer uma falha na Internet em um ano determinado (em porcentagem)</p>
                            </td>
                            <td>
                                <p>Perda de investimento estrangeiro (em USD)</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>ARGENTINA</p>
                            </td>
                            <td>
                                <p>USD $13,245,621</p>
                            </td>
                            <td>
                                <p>2.92 %</p>
                            </td>
                            <td>
                                <p>27</p>
                            </td>
                            <td>
                                <p>USD $1,766,083</p>
                            </td>
                            <td>
                                <p>2.92 %</p>
                            </td>
                            <td>
                                <p>3</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>ARUBA</p>
                            </td>
                            <td>
                                <p>USD $47,507</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>Sem dados</p>
                            </td>
                            <td>
                                <p>USD $6,334</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>Sem dados</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>BELICE</p>
                            </td>
                            <td>
                                <p>USD $53,102</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>Sem dados</p>
                            </td>
                            <td>
                                <p>USD $7,080</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>Sem dados</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>BOL&Iacute;VIA</p>
                            </td>
                            <td>
                                <p>USD $1,234,840</p>
                            </td>
                            <td>
                                <p>2.98 %</p>
                            </td>
                            <td>
                                <p>2</p>
                            </td>
                            <td>
                                <p>USD $164,645</p>
                            </td>
                            <td>
                                <p>2.98 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>BRASIL</p>
                            </td>
                            <td>
                                <p>USD $ 41,208,368</p>
                            </td>
                            <td>
                                <p>2.72 %</p>
                            </td>
                            <td>
                                <p>253</p>
                            </td>
                            <td>
                                <p>USD $5,494,449</p>
                            </td>
                            <td>
                                <p>2.72 %</p>
                            </td>
                            <td>
                                <p>33</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>CHILE</p>
                            </td>
                            <td>
                                <p>USD $ 6,109,129</p>
                            </td>
                            <td>
                                <p>3.59 %</p>
                            </td>
                            <td>
                                <p>18</p>
                            </td>
                            <td>
                                <p>USD $814,551</p>
                            </td>
                            <td>
                                <p>3.59 %</p>
                            </td>
                            <td>
                                <p>2</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>COLÔMBIA</p>
                            </td>
                            <td>
                                <p>USD $10,776,131</p>
                            </td>
                            <td>
                                <p>0%</p>
                            </td>
                            <td>
                                <p>78</p>
                            </td>
                            <td>
                                <p>USD $1,436,817</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>10</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>COSTA RICA</p>
                            </td>
                            <td>
                                <p>USD $1,338,233</p>
                            </td>
                            <td>
                                <p>3.03 %</p>
                            </td>
                            <td>
                                <p>8</p>
                            </td>
                            <td>
                                <p>USD $178,431</p>
                            </td>
                            <td>
                                <p>3.03 %</p>
                            </td>
                            <td>
                                <p>1</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>CUBA</p>
                            </td>
                            <td colspan="6">
                                <p>Sem dados</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>REP&Uacute;BLICA DOMINICANA</p>
                            </td>
                            <td>
                                <p>USD $2,699,137</p>
                            </td>
                            <td>
                                <p>3.49 %</p>
                            </td>
                            <td>
                                <p>4</p>
                            </td>
                            <td>
                                <p>USD $359,885</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>EQUADOR</p>
                            </td>
                            <td>
                                <p>USD $2,684,813</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>3</p>
                            </td>
                            <td>
                                <p>USD $357,975</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>EL SALVADOR</p>
                            </td>
                            <td>
                                <p>USD $734,144</p>
                            </td>
                            <td>
                                <p>4.01 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $97,886</p>
                            </td>
                            <td>
                                <p>4.01 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>GUIANA FRANCESA</p>
                            </td>
                            <td>
                                <p>USD $321,851</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>1</p>
                            </td>
                            <td>
                                <p>USD $42,914</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>GUATEMALA</p>
                            </td>
                            <td>
                                <p>USD $2,277,611</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>1</p>
                            </td>
                            <td>
                                <p>USD $303,681</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>GUYANA</p>
                            </td>
                            <td>
                                <p>USD $321,851</p>
                            </td>
                            <td>
                                <p>0%</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $42,914</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>HAIT&Iacute;</p>
                            </td>
                            <td>
                                <p>USD $370,249</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>30</p>
                            </td>
                            <td>
                                <p>USD $49,367</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>4</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>HONDURAS</p>
                            </td>
                            <td>
                                <p>2.71 %</p>
                                <p>&nbsp;</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>6</p>
                            </td>
                            <td>
                                <p>USD $93,600</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>M&Eacute;XICO</p>
                            </td>
                            <td>
                                <p>USD $30,013,923</p>
                            </td>
                            <td>
                                <p>2.71 %</p>
                                <p>&nbsp;</p>
                            </td>
                            <td>
                                <p>16</p>
                            </td>
                            <td>
                                <p>USD $4,001,856</p>
                            </td>
                            <td>
                                <p>2.71 %</p>
                                <p>&nbsp;</p>
                            </td>
                            <td>
                                <p>12</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>ANTILHAS HOLANDESAS</p>
                            </td>
                            <td>
                                <p>USD $19,526</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $2,603</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>NICAR&Aacute;GUA</p>
                            </td>
                            <td>
                                <p>USD $515,952</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>2</p>
                            </td>
                            <td>
                                <p>USD $68,794</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>PANAM&Aacute;</p>
                            </td>
                            <td>
                                <p>USD $1,573,209</p>
                            </td>
                            <td>
                                <p>2.74 %</p>
                            </td>
                            <td>
                                <p>3</p>
                            </td>
                            <td>
                                <p>USD $209,761</p>
                            </td>
                            <td>
                                <p>2.74 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>PARAGUAI</p>
                            </td>
                            <td>
                                <p>USD $1,089,434</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>4</p>
                            </td>
                            <td>
                                <p>USD $145,258</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>PERU</p>
                            </td>
                            <td>
                                <p>USD $5,496,941</p>
                            </td>
                            <td>
                                <p>3.02 %</p>
                            </td>
                            <td>
                                <p>7</p>
                            </td>
                            <td>
                                <p>USD $732,925</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>3.02 %</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>SURINAME</p>
                            </td>
                            <td>
                                <p>USD $122,327</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $16,310</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>TRINIDADE E TOBAGO</p>
                            </td>
                            <td>
                                <p>USD $451,804</p>
                            </td>
                            <td>
                                <p>2.52 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $60,241</p>
                            </td>
                            <td>
                                <p>2.52 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>URUGUAI</p>
                            </td>
                            <td>
                                <p>USD $1,105,827</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                            <td>
                                <p>USD $147,444</p>
                            </td>
                            <td>
                                <p>0 %</p>
                            </td>
                            <td>
                                <p>0</p>
                            </td>
                        </tr>
                    </tbody>
                </table>


                <h4 id="esquema">Esquemas de pagamento e licenciamento</h4>
                <p>Adicionalmente, foram estudados os modelos de preços, limitações e opções de presença na rede para cada solução anti-DDoS mencionada:
                    <ol>
                        <li>Cloudflare DDoS Protection
                            <ul>
                                <li>Cobrança: Oferecem de tudo, desde planos gratuitos para pequenos sites até soluções empresariais avançadas. A proteção DDoS avançada faz parte dos planos de pagamento e está incluída no Cloudflare Business e Enterprise.</li>
                                <li>Limitações: Os planos gratuitos podem limitar a mitigação e não incluem proteção personalizada para ataques específicos. Nos planos de pagamento, as limitações são baseadas no plano adquirido.</li>
                                <li>Presença na rede: A Cloudflare possui uma infraestrutura global que permite proteger sites no mundo todo sem a necessidade de configuração adicional.</li>
                                <li>Licenciamento: Os planos avançados são normalmente assinaturas mensais ou anuais, e alguns serviços empresariais podem ter taxas personalizadas com base nas necessidades de uso e mitigação.</li>
                            </ul>
                        </li>
                        <li>Imperva DDoS Protection
                            <ul>
                                <li>Cobrança: A Imperva cobra de acordo com o tráfego e a complexidade da proteção requerida. Oferece preços personalizados para empresas com alto tráfego e requisitos específicos.</li>
                                <li>Limitações: Alguns planos básicos limitam a capacidade de personalização e podem não incluir todas as camadas de proteção.</li>
                                <li>Presença na rede: Usa centros de mitigação distribuídos globalmente, permitindo que os ataques sejam gerenciados em diversas regiões sem a necessidade de infraestrutura adicional.</li>
                                <li>Licenciamento: Com base em assinatura e, em alguns casos, taxas baseadas no volume de tráfego mensal. Os planos são geralmente anuais e ajustados de acordo com as necessidades.</li>
                            </ul>
                        </li>
                        <li>Akamai Edge DNS
                            <ul>
                                <li>Cobrança: A Akamai cobra principalmente com base no tráfego DNS e nos níveis de serviço. As taxas podem variar consideravelmente, com preços personalizados para grandes empresas.</li>
                                <li>Limitações: Alguns planos de entrada podem não incluir todas as camadas de proteção ou acesso total à rede de mitigação global.</li>
                                <li>Presença na rede: Graças à sua rede global, a Akamai permite a mitigação no nível de DNS em múltiplos locais. Este serviço foi projetado para proteger contra ataques distribuídos sem intervenção local adicional.</li>
                                <li>Licenciamento: Geralmente é um modelo de assinatura mensal ou anual, e os preços podem variar de acordo com o tráfego gerenciado.</li>
                            </ul>
                        </li>
                        <li>Arbor Cloud
                            <ul>
                                <li>Cobrança: A Arbor Cloud cobra com base no volume de tráfego a ser mitigado e nas capacidades contratadas (como velocidade de mitigação). A solução pode ser cara para redes com alto tráfego.</li>
                                <li>Limitações: Existem limites na capacidade de tráfego que cada plano pode suportar. A configuração e a análise também requerem recursos especializados.</li>
                                <li>Presença na rede: A Arbor Cloud se integra a redes distribuídas de centros de dados e possui uma infraestrutura de mitigação global.</li>
                                <li>Licenciamento: Geralmente é uma assinatura anual ou mensal, e alguns serviços específicos podem ser cobrados adicionalmente.</li>
                            </ul>
                        </li>
                        <li>Amazon Web Services (AWS) Shield
                            <ul>
                                <li>Cobrança: AWS Shield Standard é gratuito para usuários de AWS, enquanto o Shield Advanced tem um custo baseado no tráfego de mitigação e na infraestrutura protegida.</li>
                                <li>Limitações: Shield Standard tem limitações quanto ao tipo e volume de ataques que pode mitigar. Shield Advanced tem limites ajustáveis com base na configuração e no volume de tráfego.</li>
                                <li>Presença na rede: AWS Shield aproveita a infraestrutura de AWS em todo o mundo, protegendo recursos em qualquer região de AWS.</li>
                                <li>Licenciamento: Shield Advanced é pago com base em uma assinatura mensal, mais cobranças adicionais com base no tráfego mitigado e nos recursos protegidos.</li>
                            </ul>
                        </li>
                        <li>HAProxy
                            <ul>
                                <li>Cobrança: HAProxy é uma solução gratuita e de código aberto, embora existam versões comerciais (HAProxy Enterprise) que incluem suporte e recursos adicionais.</li>
                                <li>Limitações: Como balanceador de carga, o HAProxy requer configurações manuais para mitigar DDoS e não foi projetado para proteger contra grandes ataques DDoS sem a ajuda de hardware adicional.</li>
                                <li>Presença na rede: O HAProxy precisa ser configurado em diferentes locais de rede para fornecer cobertura em múltiplos pontos. Requer infraestrutura distribuída do cliente.</li>
                                <li>Licenciamento: A versão de código aberto é gratuita. HAProxy Enterprise tem uma taxa de licença que inclui suporte e funcionalidade adicionais.</li>
                            </ul>
                        </li>
                        <li>Gatekeeper
                            <ul>
                                <li>Cobrança: A maioria das soluções Gatekeeper são personalizadas e suas taxas dependem da escala da rede a ser protegida e do volume de tráfego.</li>
                                <li>Limitações: A implementação do Gatekeeper pode ter limitações na complexidade do ataque e no volume de tráfego e geralmente requer configurações personalizadas.</li>
                                <li>Presença na rede: Requer a implementação de sua solução nos pontos de presença do cliente, o que envolve infraestrutura distribuída.</li>
                                <li>Licenciamento: Geralmente, é um modelo de licenciamento anual, com preços ajustados com base nas necessidades específicas de rede e tráfego.</li>
                            </ul>
                        </li>
                        <li>FastNetMon
                            <ul>
                                <li>Cobrança: FastNetMon é gratuito em sua versão de código aberto e possui uma versão Pro, paga, com funcionalidades avançadas.</li>
                                <li>Limitações: FastNetMon requer configuração específica e conhecimento técnico para ser configurado como uma solução anti-DDoS completa. Também pode ser limitado às capacidades da rede subjacente.</li>
                                <li>Presença na rede: Pode ser implantado em vários pontos da rede do cliente para monitoramento e proteção em tempo real, mas requer sua própria infraestrutura distribuída.</li>
                                <li>Licenciamento: A versão Pro é adquirida sob licença, com custo baseado na quantidade de instâncias e no suporte desejado.</li>
                            </ul>
                        </li>
                    </ol>
                </p>
                <p>Cada uma destas soluções tem modelos de cobrança, limitações e requisitos de infraestrutura específicos, permitindo que se adaptem a necessidades e orçamentos variados. Recomenda-se obter informações mais detalhadas no site oficial de cada solução.</p>

            </UseLang>
        </div>
    )
}

export default Relevamiento
